/* ciw la package scope detection v2 */
/* ciw-cache-bust-2026-07-13-semi-pkg */
/* ciw-cache-bust-2026-07-13-pkg-desc */

(function () {
  var STEP_SELECTORS = [
    '.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)',
    '.la-choose-prescription-wrapper.la-render-addons'
  ];
  var THICKNESS_SCOPE_CLASS = 'ciw-la-lens-thickness-step';
  var LENS_PACKAGE_SCOPE_CLASS = 'ciw-la-lens-package-step';
  var LENS_PACKAGE_CONTENT_BODY_CLASS = 'ciw-la-lens-package-content-body';
  var THICKNESS_STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-options';
  var LENS_GROUP_STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-lenses.x-pro';

  function isLikelyThicknessTierName(name) {
    return /^(basic|standard|polycarbonate|premium|supreme\+?)$/i.test(
      String(name || '')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' - ')[0]
    );
  }

  function isLensColorOptionTitle(title) {
    var label = String(title || '').replace(/\s+/g, ' ').trim();
    return (
      /select\s+choose\s+color\s+for\s+photo\s*c?r?omic/i.test(label) ||
      /choose\s+color\s+for\s+photo\s*c?r?omic/i.test(label) ||
      /select\s+choose\s+color/i.test(label) ||
      /select\s+transition\s+color\s+for\s+transitions\s+gen\s*s/i.test(label) ||
      /select\s+transition\s+color/i.test(label) ||
      /select\s+transition\s+x\s*tract?ive\s+color\s+for\s+transitions\s+xtr\s*active/i.test(label) ||
      /select\s+transition\s+x\s*tract?ive\s+color/i.test(label) ||
      /(?:photo\s*c?r?omic|transitions?\s+gen\s*s|transitions?\s+xtr\s*active|xtractive).+\bcolor\b|\bcolor\b.+(?:photo\s*c?r?omic|transitions?\s+gen\s*s|xtr\s*active|xtractive)/i.test(
        label
      ) ||
      /transition\s*color|lens\s*color|photochromic\s*color|xtr\s*active\s*color|xtractive\s*color|^color$/i.test(
        label
      )
    );
  }

  function isLikelyLensColorCardName(name) {
    var label = String(name || '')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' - ')[0];
    if (!label || isLikelyThicknessTierName(label)) return false;
    return /^(gray|grey|brown|green|graphite|amber|amethyst|ruby|sapphire|emerald|blue|yellow|rose|red|pink|purple|g[\s.-]?15|style\s*colors?)/i.test(
      label
    );
  }

  /* True when the scope currently SHOWS color cards (Gray/Brown/etc.). During LA's
     slow color -> lens-package transition, LA leaves the color cards visible for ~2s
     while it pre-renders the package tier cards into the same wrapper. A real lens
     thickness step never shows color cards, so this reliably flags the transition
     transient — used to keep the thickness "box" styling off the outgoing color step
     (see getThicknessScope). */
  function hasVisibleColorCards(scope) {
    if (!scope) return false;
    var btns = scope.querySelectorAll('.la-label-btn');
    var count = 0;
    var i;
    for (i = 0; i < btns.length; i++) {
      var titleNode = btns[i].querySelector('.la-label-title');
      if (!titleNode) continue;
      var name = titleNode.textContent.replace(/\s+/g, ' ').trim();
      if (!isLikelyLensColorCardName(name)) continue;
      var rect = btns[i].getBoundingClientRect();
      var style = window.getComputedStyle(btns[i]);
      if (rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden') {
        count++;
        if (count >= 2) return true;
      }
    }
    return false;
  }

  function isTransitionsLensFlowFromDom() {
    var groupStep = document.querySelector(LENS_GROUP_STEP_SELECTOR);
    if (!groupStep) return false;

    var checked = groupStep.querySelector('input[type="radio"].la-tap-select:checked');
    if (!checked) return false;

    var btn = checked.closest('.la-label-btn');
    var titleNode = btn && btn.querySelector('.la-label-title');
    var label = titleNode ? titleNode.textContent : checked.value || '';
    return /transition|photochromic|xtr\s*active|xtractive/i.test(String(label || '').replace(/\s+/g, ' ').trim());
  }

  function isTransitionsLensFlow(la) {
    la = la || window.LensAdvizor;
    if (la && la.response) {
      if (la.lensGroups && la.response.lensGroupSelected) {
        var selectedKey = la.response.lensGroupSelected;
        var i;
        for (i = 0; i < la.lensGroups.length; i++) {
          var group = la.lensGroups[i];
          if (group.group_type !== selectedKey && String(group.id) !== String(selectedKey)) {
            continue;
          }
          var title = String(group.group_title || group.title || '')
            .replace(/\s+/g, ' ')
            .trim();
          if (/transition|photochromic|xtr\s*active|xtractive/i.test(title)) return true;
        }
      }

      var lens = la.response.lens;
      if (lens) {
        var groupTitle = String(lens.group_title || '')
          .replace(/\s+/g, ' ')
          .trim();
        var groupType = String(lens.group_type || '')
          .replace(/\s+/g, ' ')
          .trim();
        if (
          /transition|photochromic|xtr\s*active|xtractive/i.test(groupTitle) ||
          /transition|photochromic|xtr\s*active|xtractive/i.test(groupType)
        ) {
          return true;
        }
      }
    }

    return isTransitionsLensFlowFromDom();
  }

  function isCombinedColorAndThicknessScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;
    var counts = countLensPackageScopeCards(scope);
    return counts.colorCount >= 1 && counts.tierCount >= 2;
  }

  function isThicknessOptionScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;

    var title = getLensPackageScopeTitle(scope);
    if (/choose\s+lens\s+package/i.test(title)) return false;
    if (/lens\s*thickness|lens\s*material|^material$/i.test(title)) return true;
    if (isLensColorOptionTitle(title)) return false;

    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    if (!wrappers.length) return false;

    var tierCount = 0;
    var colorCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
      if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      else if (isLikelyLensColorCardName(cardTitle)) colorCount++;
    }

    if (colorCount >= 1 && tierCount < 2) return false;

    return tierCount >= 2;
  }

  function getThicknessScope(root) {
    var rootNode = root || document;
    var scopes = rootNode.querySelectorAll(THICKNESS_STEP_SELECTOR);
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (!isTransitionsLensFlow()) continue;
      /* Color cards still on screen -> this is the color step or the color -> package
         transition transient, never a real thickness step. Skipping it here keeps the
         thickness "box" styling from flashing over the outgoing color cards. */
      if (hasVisibleColorCards(scopes[i])) continue;
      if (
        window.ciwLaLensColorContinue &&
        typeof window.ciwLaLensColorContinue.isCombinedColorPhase === 'function' &&
        window.ciwLaLensColorContinue.isCombinedColorPhase() &&
        isCombinedColorAndThicknessScope(scopes[i])
      ) {
        continue;
      }
      if (
        window.ciwLaLensColorContinue &&
        typeof window.ciwLaLensColorContinue.isColorScope === 'function' &&
        window.ciwLaLensColorContinue.isColorScope(scopes[i])
      ) {
        continue;
      }
      if (isThicknessOptionScope(scopes[i])) return scopes[i];
      var wrappers = scopes[i].querySelectorAll('.la-label-btn-wrapper');
      var tierCount = 0;
      var j;
      for (j = 0; j < wrappers.length; j++) {
        var titleNode = wrappers[j].querySelector('.la-label-title');
        var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
        if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      }
      if (tierCount >= 2 && !/choose\s+lens\s+package/i.test(getLensPackageScopeTitle(scopes[i]))) {
        return scopes[i];
      }
    }
    return null;
  }

  function getLensPackageScopeTitle(scope) {
    if (!scope) return '';

    function readTitleEl(titleEl) {
      return titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3') ||
      scope.querySelector('.la-wrapper-heading h2') ||
      scope.querySelector('.la-wrapper-heading');
    var title = readTitleEl(titleEl);
    if (title) return title;

    var body = scope.closest('.la-prescription-modal-content-body');
    if (!body) return '';

    titleEl =
      body.querySelector('#la_prescriptionSelect_title') ||
      body.querySelector(':scope > .la-wrapper-heading h3') ||
      body.querySelector(':scope > .la-wrapper-heading h2') ||
      body.querySelector(':scope > .la-wrapper-heading');
    return readTitleEl(titleEl);
  }

  function isScopeVisible(scope) {
    if (!scope || scope.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(scope);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return scope.getClientRects().length > 0;
  }

  function getLensPackageCardWrappers(scope) {
    if (!scope) return [];
    var seen = typeof Set !== 'undefined' ? new Set() : null;
    var result = [];
    scope.querySelectorAll('.la-label-btn-wrapper, .la-horizontal-boxy-label-wrapper').forEach(function (wrapper) {
      if (seen) {
        if (seen.has(wrapper)) return;
        seen.add(wrapper);
      } else if (result.indexOf(wrapper) !== -1) {
        return;
      }
      result.push(wrapper);
    });
    return result;
  }

  function countLensPackageScopeCards(scope) {
    var wrappers = getLensPackageCardWrappers(scope);
    var tierCount = 0;
    var typeCount = 0;
    var colorCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
      if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      else if (isLikelyTransitionTypeName(cardTitle)) typeCount++;
      else if (isLikelyLensColorCardName(cardTitle)) colorCount++;
    }
    return { tierCount: tierCount, typeCount: typeCount, colorCount: colorCount, wrappers: wrappers.length };
  }

  function isLensPackageTransitionTypeScope(scope) {
    if (!scope) return false;
    var title = getLensPackageScopeTitle(scope);
    if (isLensColorOptionTitle(title)) return false;
    var counts = countLensPackageScopeCards(scope);
    return counts.typeCount >= 1 && counts.tierCount < 2 && counts.colorCount < 2;
  }

  function getSelectedProgressiveTypeNameFromDom() {
    var lensesStep = document.querySelector('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)');
    if (!lensesStep) return '';

    function cardNameFromWrapper(wrapper) {
      var titleNode = wrapper && wrapper.querySelector('.la-label-title');
      return titleNode
        ? String(titleNode.textContent || '')
            .replace(/\s+/g, ' ')
            .trim()
            .split(' - ')[0]
        : '';
    }

    var checked = lensesStep.querySelector('input[type="radio"].la-tap-select:checked');
    if (checked) {
      var checkedLabel = cardNameFromWrapper(
        checked.closest('.la-label-btn-wrapper, .la-horizontal-boxy-label-wrapper')
      );
      if (isLikelyProgressiveTypeCardName(checkedLabel)) return checkedLabel;
    }

    var pickedTitleNode = lensesStep.querySelector('.ciw-la-lens-card--picked .la-label-title');
    if (pickedTitleNode) {
      var pickedLabel = String(pickedTitleNode.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' - ')[0];
      if (isLikelyProgressiveTypeCardName(pickedLabel)) return pickedLabel;
    }

    return '';
  }

  function getSelectedProgressiveTypeName() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.lens && la.response.lens.name) {
      var lensName = String(la.response.lens.name)
        .replace(/\s+/g, ' ')
        .trim()
        .split(' - ')[0];
      if (isLikelyProgressiveTypeCardName(lensName)) return lensName;
    }
    return getSelectedProgressiveTypeNameFromDom();
  }

  function isProgressivePackageOptionScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;
    if (!isProgressivePrescriptionFlow() || isTransitionsLensFlow()) return false;
    if (!getSelectedProgressiveTypeName()) return false;

    var lensesStep = document.querySelector('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)');
    if (lensesStep && isScopeVisible(lensesStep) && isProgressiveTypeStepScope(lensesStep)) {
      return false;
    }

    var counts = countLensPackageScopeCards(scope);
    if (counts.tierCount >= 2 && counts.colorCount === 0) return true;

    var title = getLensPackageScopeTitle(scope);
    return (
      /choose\s+lens\s+package|select\s+lens\s+thickness/i.test(title) && counts.tierCount >= 2
    );
  }

  function getProgressivePackageScope(root) {
    var rootNode = root || document;
    if (!isProgressivePrescriptionFlow() || isTransitionsLensFlow()) return null;
    if (!getSelectedProgressiveTypeName()) return null;

    var scopes = rootNode.querySelectorAll(THICKNESS_STEP_SELECTOR);
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (!isScopeVisible(scopes[i])) continue;
      if (!isProgressivePackageOptionScope(scopes[i])) continue;
      return scopes[i];
    }
    return null;
  }

  function isLensPackageOptionScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;
    if (isProgressivePackageOptionScope(scope)) return true;
    if (isLensPackageTransitionTypeScope(scope)) return false;
    if (
      window.ciwLaLensColorContinue &&
      typeof window.ciwLaLensColorContinue.isCombinedColorPhase === 'function' &&
      window.ciwLaLensColorContinue.isCombinedColorPhase() &&
      isCombinedColorAndThicknessScope(scope)
    ) {
      return false;
    }
    if (
      window.ciwLaLensColorContinue &&
      typeof window.ciwLaLensColorContinue.isColorScope === 'function' &&
      window.ciwLaLensColorContinue.isColorScope(scope)
    ) {
      return false;
    }
    var title = getLensPackageScopeTitle(scope);
    if (/choose\s+lens\s+package|select\s+lens\s+thickness/i.test(title)) {
      var titleCounts = countLensPackageScopeCards(scope);
      return titleCounts.tierCount >= 2;
    }
    var counts = countLensPackageScopeCards(scope);
    return counts.tierCount >= 2 && counts.typeCount < 1;
  }

  function getLensPackageScope(root) {
    var rootNode = root || document;
    var progressiveScope = getProgressivePackageScope(rootNode);
    if (progressiveScope) return progressiveScope;

    var scopes = rootNode.querySelectorAll('.la-choose-prescription-wrapper.la-render-options');
    var fallback = null;
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (!isLensPackageOptionScope(scopes[i])) continue;
      if (isScopeVisible(scopes[i])) return scopes[i];
      if (!fallback) fallback = scopes[i];
    }
    return fallback;
  }

  function shouldApplyLensPackageInlineWidths(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;
    if (scope.classList.contains('ciw-la-lens-color-step')) return false;
    if (!isScopeVisible(scope)) return false;
    if (
      window.ciwLaLensColorContinue &&
      typeof window.ciwLaLensColorContinue.isColorScope === 'function' &&
      window.ciwLaLensColorContinue.isColorScope(scope)
    ) {
      return false;
    }
    var counts = countLensPackageScopeCards(scope);
    return counts.tierCount >= 2;
  }

  function applyLensPackageStepInlineWidths(scope) {
    if (!scope) return;
    scope.querySelectorAll('.la-prescription-wrapper.la-option-container').forEach(function (el) {
      el.style.setProperty('padding-left', '0', 'important');
      el.style.setProperty('padding-right', '0', 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
    });
    scope
      .querySelectorAll(
        '.la-horizontal-boxy-layout-wrapper, .la-horizontal-boxy-lenses-wrapper, .la-horizontal-boxy-label-wrapper, .la-label-btn-wrapper, label.la-label-btn, div.la-label-btn'
      )
      .forEach(function (el) {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('max-width', '100%', 'important');
        el.style.setProperty('flex-basis', '100%', 'important');
        el.style.setProperty('flex', '1 1 100%', 'important');
        el.style.setProperty('box-sizing', 'border-box', 'important');
      });
  }

  function scanLensPackageInlineWidths(root) {
    var rootNode = root || document;
    rootNode.querySelectorAll('.la-choose-prescription-wrapper.la-render-options').forEach(function (scope) {
      if (!shouldApplyLensPackageInlineWidths(scope)) return;
      applyLensPackageStepInlineWidths(scope);
    });
  }

  function syncLensPackageContentBodyLayout(root) {
    var rootNode = root || document;
    var contentBody = rootNode.querySelector(
      '#lensadvizor-prescription-modal .la-prescription-modal-content-body'
    );
    if (!contentBody) return;

    var active = getLensPackageScope(rootNode);
    var needsColumnStack = active && isMobileViewport();

    if (needsColumnStack) {
      contentBody.classList.add(LENS_PACKAGE_CONTENT_BODY_CLASS);
      contentBody.style.setProperty('display', 'flex', 'important');
      contentBody.style.setProperty('flex-direction', 'column', 'important');
      contentBody.style.setProperty('align-items', 'stretch', 'important');
      return;
    }

    contentBody.classList.remove(LENS_PACKAGE_CONTENT_BODY_CLASS);
    contentBody.style.removeProperty('display');
    contentBody.style.removeProperty('flex-direction');
    contentBody.style.removeProperty('align-items');
  }

  function clearStaleThicknessScopes(root) {
    var rootNode = root || document;
    var active = getThicknessScope(rootNode);
    rootNode.querySelectorAll('.' + THICKNESS_SCOPE_CLASS).forEach(function (el) {
      if (el !== active) el.classList.remove(THICKNESS_SCOPE_CLASS);
    });
  }

  function formatPriceText(raw) {
    if (!raw) return '';
    var text = raw.replace(/\s+/g, ' ').trim().replace(/^\+/, '');
    if (/^selected$/i.test(text)) return '';
    if (/^free$/i.test(text) || /^included$/i.test(text)) {
      return 'FREE';
    }
    if (/^\$?0(?:\.00)?$/i.test(text)) {
      return 'FREE';
    }
    var match = text.match(/\$[\d,]+(?:\.\d{2})?/);
    if (match) {
      var amount = match[0].replace(/\.00$/, '');
      if (/^\$0(?:\.00)?$/i.test(amount) || amount === '$0') {
        return 'FREE';
      }
      return '+' + amount;
    }
    return '+' + text;
  }

  function getPriceText(priceEl) {
    if (!priceEl) return '';

    var btn = priceEl.closest('.la-label-btn');
    var wrapper = priceEl.closest('.la-label-btn-wrapper');
    var radio =
      (btn &&
        (btn.querySelector('input[type="radio"].la-tap-select') ||
          btn.querySelector('input[type="radio"]'))) ||
      (wrapper &&
        (wrapper.querySelector('input[type="radio"].la-tap-select') ||
          wrapper.querySelector('input[type="radio"]')));

    var sourceEl = priceEl;

    if (radio && radio.checked) {
      var dataPrice =
        (btn && btn.getAttribute('data-ciw-la-original-price')) ||
        priceEl.getAttribute('data-price') ||
        priceEl.getAttribute('data-original-price') ||
        radio.getAttribute('data-price') ||
        radio.getAttribute('data-option-price') ||
        radio.getAttribute('data-raw-price') ||
        '';

      if (dataPrice) {
        var fromData = formatPriceText(dataPrice);
        if (fromData) return fromData;
        if (/^$|^\$?0(?:\.00)?$/i.test(String(dataPrice).replace(/\s+/g, ' ').trim())) {
          return 'FREE';
        }
      }

      var group = wrapper && wrapper.parentElement;
      if (group && radio.value) {
        var siblings = group.querySelectorAll('.la-label-btn-wrapper');
        var i;
        for (i = 0; i < siblings.length; i++) {
          if (siblings[i] === wrapper) continue;
          var sibRadio =
            siblings[i].querySelector('input[type="radio"].la-tap-select') ||
            siblings[i].querySelector('input[type="radio"]');
          if (!sibRadio || sibRadio.checked) continue;
          if (String(sibRadio.value) !== String(radio.value)) continue;
          var sibPrice = siblings[i].querySelector('.la-label-price');
          if (sibPrice) {
            sourceEl = sibPrice;
            break;
          }
        }
      }
    }

    var clone = sourceEl.cloneNode(true);
    var compare = clone.querySelector('.la-compare-at-price');
    if (compare) compare.remove();
    var raw = (clone.textContent || '').trim();
    var formatted = formatPriceText(raw);

    if (formatted && btn && !/^selected$/i.test(raw.replace(/^\+/, '').trim())) {
      btn.setAttribute('data-ciw-la-original-price', raw.replace(/^\+/, '').trim());
    }

    if (!formatted) return 'FREE';
    return formatted;
  }

  function isRecommendationWrapper(el) {
    if (!el) return false;
    return (
      el.classList.contains('recommendation-label-container') ||
      el.classList.contains('boxy-recommendation-label-container')
    );
  }

  function findBadgeWrapper(outerWrapper) {
    if (!outerWrapper) return null;
    var child = outerWrapper.firstElementChild;
    while (child) {
      if (child.classList.contains('lens-recommendation-badge-wrapper')) {
        return child;
      }
      child = child.nextElementSibling;
    }
    return null;
  }

  function hideLaBadgeWrapper(badgeWrap) {
    if (!badgeWrap) return;
    badgeWrap.setAttribute('aria-hidden', 'true');
    badgeWrap.style.setProperty('display', 'none', 'important');
    badgeWrap.style.setProperty('height', '0', 'important');
    badgeWrap.style.setProperty('overflow', 'hidden', 'important');
    badgeWrap.style.setProperty('padding', '0', 'important');
    badgeWrap.style.setProperty('margin', '0', 'important');
  }

  function ensureRecBadge(btn, titleRow) {
    var outerWrapper = btn.closest('.la-label-btn-wrapper');
    if (!outerWrapper || !titleRow) return;
    if (!isRecommendationWrapper(outerWrapper)) return;

    var badgeWrap = findBadgeWrapper(outerWrapper);
    var pill = titleRow.querySelector('.ciw-la-lens-rec-badge');

    if (!pill) {
      var text = 'Recommended for you';
      if (badgeWrap) {
        var laBadge = badgeWrap.querySelector('.lens-recommendation-badge');
        if (laBadge && laBadge.textContent) {
          text = laBadge.textContent.replace(/\s+/g, ' ').trim() || text;
        }
      }

      pill = document.createElement('span');
      pill.className = 'ciw-la-lens-rec-badge';
      pill.textContent = text;
      titleRow.appendChild(pill);
    }

    hideLaBadgeWrapper(badgeWrap);
    outerWrapper.classList.add('ciw-la-lens-card--badge-moved');
  }

  function pinPriceToCard(btn, head) {
    var hiddenPrice = btn.querySelector('.la-label-price');
    var priceInline =
      btn.querySelector('.ciw-la-lens-card-price-inline') ||
      (head && head.querySelector('.ciw-la-lens-card-price-inline'));
    var priceText = getPriceText(hiddenPrice);

    if (!priceInline && priceText) {
      priceInline = document.createElement('span');
      priceInline.className = 'ciw-la-lens-card-price-inline';
      priceInline.textContent = priceText;
      btn.appendChild(priceInline);
    } else if (priceInline && priceText) {
      priceInline.textContent = priceText;
    }

    if (hiddenPrice && priceInline) {
      hiddenPrice.classList.add('ciw-la-lens-card-price-hidden');
    }

    if (priceInline && priceInline.parentNode !== btn) {
      btn.appendChild(priceInline);
    }
  }

  function markBasicCard(btn) {
    var title = btn.querySelector('.la-label-title');
    var titleText = (title && title.textContent ? title.textContent : '')
      .replace(/\s+/g, ' ')
      .trim();
    if (/^basic$/i.test(titleText)) {
      btn.classList.add('ciw-la-lens-card--basic');
    } else {
      btn.classList.remove('ciw-la-lens-card--basic');
    }
  }

  function markDeclineCard(btn) {
    var title = btn.querySelector('.la-label-title');
    var titleText = (title && title.textContent ? title.textContent : '')
      .replace(/\s+/g, ' ')
      .trim();
    if (/no thanks,\s*basic anti-glare is fine/i.test(titleText)) {
      btn.classList.add('ciw-la-lens-card--decline');
    } else {
      btn.classList.remove('ciw-la-lens-card--decline');
    }
  }

  function findIconWrap(btn) {
    var iconWrap =
      btn.querySelector('.la-label-image-wapper') ||
      btn.querySelector('.la-label-image-wapper .la-label-image');
    if (iconWrap) return iconWrap;

    var child = btn.firstElementChild;
    while (child) {
      if (child.classList.contains('la-label-image')) {
        return child;
      }
      child = child.nextElementSibling;
    }
    return null;
  }

  function getCardTitleText(btn) {
    var title = btn.querySelector('.la-label-title');
    return (title && title.textContent ? title.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function isLensTypeStepBtn(btn) {
    return !!btn.closest('.la-choose-prescription-wrapper.la-render-lenses.x-pro');
  }

  function isBlueLightBlockingLensType(btn) {
    return /blue\s*light/i.test(getCardTitleText(btn));
  }

  function isNonTransitionsLensTypeTitle(title) {
    return /^(clear|blue\s*light|sunglass(?:es)?|polarized|non[\s-]?polarized)\b/i.test(
      String(title || '')
        .replace(/\s+/g, ' ')
        .trim()
    );
  }

  function isTransitionsLensType(btn) {
    var label = getCardTitleText(btn);
    if (!label || isNonTransitionsLensTypeTitle(label)) return false;
    return /\btransitions?\b|photochromic|xtr\s*active|xtractive/i.test(label);
  }

  var GUSA_TRANSITIONS_LOGO_VIEWBOX = '0 0 449 121';

  var GUSA_TRANSITIONS_LOGO_PATHS = [
    {
      d:
        'M349.864.5c.38 0 .625.422.431.751l-20.85 35.969a29.39 29.39 0 0 1 11.166 23.105 29.527 29.527 0 0 1-40.435 27.394l-18.854 32.528a.48.48 0 0 1-.43.253h-7.011a.492.492 0 0 1-.431-.742L342.423.753a.48.48 0 0 1 .431-.253zM187.656 34.188a29.77 29.77 0 0 1 17.718 5.762.54.54 0 0 1 0 .751l-2.877 4.387a.56.56 0 0 1-.376.216.57.57 0 0 1-.417-.114c-4.126-2.86-9.171-4.834-13.702-4.834-4.91 0-7.307 2.193-7.307 5.433.001 10.596 26.02 10.108 26.012 26.02 0 7.905-6.463 14.655-17.532 14.655a26.86 26.86 0 0 1-18.739-7.298.633.633 0 0 1 0-.844l3.425-4.37a.42.42 0 0 1 .3-.129.42.42 0 0 1 .299.128 19.52 19.52 0 0 0 14.124 6.033c5.357 0 8.791-2.531 8.791-6.75 0-11.035-25.809-9.686-25.809-26.34.001-6.8 5.274-12.706 16.09-12.706m54.191-12.058a.507.507 0 0 1 .507.508l1.164 13.128h13.499a.507.507 0 0 1 .506.506v5.35a.505.505 0 0 1-.506.505h-12.832v28.534c0 9.23 6.31 11.634 14.131 8.437a.54.54 0 0 1 .62.2.55.55 0 0 1 .088.214l.802 4.193a.59.59 0 0 1-.354.64 20.8 20.8 0 0 1-9.213 2.11c-7.821 0-15.752-3.56-15.752-14.942l.084-48.875a.48.48 0 0 1 .507-.507zm172.976 12.083a29.77 29.77 0 0 1 17.718 5.763.55.55 0 0 1 .051.75l-2.877 4.387a.576.576 0 0 1-.793.077c-4.126-2.86-9.172-4.834-13.702-4.834-4.911 0-7.307 2.193-7.307 5.433.001 10.596 26.011 10.108 25.952 25.994 0 7.906-6.463 14.656-17.532 14.656a26.86 26.86 0 0 1-18.738-7.298.64.64 0 0 1 0-.844l3.433-4.32a.42.42 0 0 1 .3-.128.4.4 0 0 1 .3.128 19.52 19.52 0 0 0 14.123 6.032c5.357 0 8.792-2.53 8.792-6.75 0-11.035-25.81-9.685-25.81-26.34.001-6.8 5.274-12.706 16.09-12.706',
    },
    {
      d:
        'M91.643 34.23c12.984 0 19.253 6.707 19.27 18.452v31.613a.52.52 0 0 1-.148.358.5.5 0 0 1-.359.149h-6.327a.5.5 0 0 1-.498-.414l-.574-2.118c-3.139 2.531-8.302 4.025-12.832 4.025-11.964 0-19.145-6.066-19.145-16.427 0-9.947 7.712-16.258 20.528-16.259 3.438.074 6.858.538 10.192 1.384v-3.839c0-6.488-3.527-10.757-11.12-10.757a28.74 28.74 0 0 0-12.495 2.987.592.592 0 0 1-.844-.346c-.43-1.476-.886-2.936-1.274-4.32a.77.77 0 0 1 .396-.92 37.2 37.2 0 0 1 15.23-3.568m2.218 25.353c-9.643 0-13.018 3.83-13.018 10.015 0 6.344 3.417 10.082 12.166 10.083a17.7 17.7 0 0 0 8.758-2.777l-.034-16.317a33 33 0 0 0-7.872-1.004',
      fillRule: 'evenodd',
    },
    {
      d:
        'M373.416 34.18c10.934 0 18.072 5.974 18.072 16.968V84.22a.5.5 0 0 1-.148.358.5.5 0 0 1-.359.149h-8.546a.51.51 0 0 1-.506-.507V52.093c0-7.5-3.646-10.968-11.129-10.968a20.47 20.47 0 0 0-12.554 4.31v38.753a.51.51 0 0 1-.312.467.5.5 0 0 1-.195.038h-8.504a.5.5 0 0 1-.358-.148.5.5 0 0 1-.148-.358V36.274q0-.1.039-.193a.5.5 0 0 1 .467-.312h7.155a.506.506 0 0 1 .498.472l.607 3.265c4.008-3.265 10.353-5.324 15.921-5.324M51.626 17.299a.53.53 0 0 1 .378.144.52.52 0 0 1 .162.37v5.805a.524.524 0 0 1-.515.507H30.736v60.064a.505.505 0 0 1-.514.505h-8.918a.515.515 0 0 1-.515-.505V24.125H.54a.525.525 0 0 1-.54-.507v-5.804a.523.523 0 0 1 .54-.515zm94.344 16.772c10.892 0 18.055 5.957 18.055 16.925v33.192a.5.5 0 0 1-.312.468.5.5 0 0 1-.194.037h-8.497a.507.507 0 0 1-.505-.505V51.94c0-7.466-3.645-10.926-11.137-10.926a20.4 20.4 0 0 0-12.546 4.311v38.862a.51.51 0 0 1-.313.467.5.5 0 0 1-.193.038h-8.539a.507.507 0 0 1-.506-.505V36.164a.51.51 0 0 1 .506-.507h7.147a.497.497 0 0 1 .505.473l.6 3.265c4.008-3.273 10.36-5.324 15.929-5.324',
    },
    {
      d:
        'M66.458 34.188a16 16 0 0 1 5.205.961.36.36 0 0 1 .194.431l-1.341 5.56a.36.36 0 0 1-.472.227 13.4 13.4 0 0 0-4.464-.657c-6.758 0-11.213 5.981-11.213 11.972v31.504c0 .278-.084.505-.362.505h-8.438a.505.505 0 0 1-.505-.505V36.28a.507.507 0 0 1 .505-.507h7.147a.5.5 0 0 1 .498.473l.48 5.231a14.16 14.16 0 0 1 12.766-7.29m156.449 1.586c.28 0 .507.227.507.506v47.907a.506.506 0 0 1-.507.505h-8.285a.506.506 0 0 1-.506-.505V36.279c0-.279.227-.505.506-.506zm50.757 0c.28 0 .507.227.507.506v47.907a.506.506 0 0 1-.507.505h-8.285a.506.506 0 0 1-.506-.505V36.279c0-.279.227-.505.506-.506zm37.442-4.943c2.94-.002 5.864.435 8.674 1.299l-3.257 5.425a23 23 0 0 0-5.332-.633c-13.111 0-22.636 9.855-22.636 23.042a22.52 22.52 0 0 0 5.905 15.692l-3.501 6.185a30.5 30.5 0 0 1-9.517-21.937c.001-17.076 13.542-29.073 29.664-29.073m130.733 6.98h-1.687v4.597h-1.316l-.051-4.64h-1.687v-1.114h4.741zm4.067 1.231 1.51-2.43h1.35v5.754h-1.232v-3.89l-1.595 2.532h-.109l-1.586-2.531v3.89h-1.24V36.61h1.384zm-227.1-19.407a5.22 5.22 0 0 1 5.214 5.222 5.225 5.225 0 0 1-6.246 5.121 5.222 5.222 0 0 1 1.032-10.343m50.756 0a5.224 5.224 0 0 1 1.989 10.049 5.224 5.224 0 0 1-6.82-6.831 5.23 5.23 0 0 1 4.831-3.218',
    },
  ];

  function buildGusaTransitionsLogoSvg() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('viewBox', GUSA_TRANSITIONS_LOGO_VIEWBOX);
    svg.setAttribute('aria-hidden', 'true');
    GUSA_TRANSITIONS_LOGO_PATHS.forEach(function (pathData) {
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('fill', '#0f0f0f');
      path.setAttribute('d', pathData.d);
      if (pathData.fillRule) {
        path.setAttribute('fill-rule', pathData.fillRule);
        path.setAttribute('clip-rule', pathData.fillRule);
      }
      svg.appendChild(path);
    });
    return svg;
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function restoreTransitionsTitleText(btn) {
    if (!btn) return;
    var title = btn.querySelector('.la-label-title');
    if (!title) return;
    title.querySelectorAll('la-translate.ciw-la-transitions-title-hidden').forEach(function (node) {
      node.classList.remove('ciw-la-transitions-title-hidden');
      node.removeAttribute('aria-hidden');
    });
  }

  function restoreTransitionsDescriptionSpacing(btn) {
    if (!btn) return;
    var description = btn.querySelector('.la-label-description');
    if (description) {
      description.style.removeProperty('margin-top');
    }
  }

  function restoreTransitionsCardChrome(btn) {
    restoreTransitionsTitleText(btn);
    restoreTransitionsDescriptionSpacing(btn);
  }

  function syncTransitionsDescriptionSpacing(btn) {
    var description = btn && btn.querySelector('.la-label-description');
    if (!description) return;

    description.style.removeProperty('margin-top');
  }

  var INJECTED_THUMB_CLASS = 'ciw-la-transitions-thumb-injected';

  function removeInjectedTransitionsThumb(btn) {
    if (!btn) return;
    var injected = btn.querySelector('.' + INJECTED_THUMB_CLASS);
    if (injected) injected.remove();
  }

  /* Some flows (e.g. Bifocal) ship the Transitions lens GROUP with an empty image in
     LensAdvizor, so LA renders the Lens Type card with no .la-label-image thumbnail —
     while Distance/Reading/etc. render it fine. Restore the missing lens-preview
     thumbnail from a vendored theme asset so every flow looks consistent. Only injects
     when LA left no image of its own; if LA later provides one, ours is removed. */
  function ensureTransitionsLensThumbnail(btn) {
    if (!btn) return;

    var thumbUrl = window.ciwLaLensLayout && window.ciwLaLensLayout.transitionsThumb;
    if (!thumbUrl) return;

    var laImage = btn.querySelector('.la-label-image');
    if (laImage && !laImage.classList.contains(INJECTED_THUMB_CLASS)) {
      removeInjectedTransitionsThumb(btn);
      return;
    }
    if (laImage) return;

    var imageWrap = document.createElement('div');
    imageWrap.className = 'la-label-image ' + INJECTED_THUMB_CLASS;
    var img = document.createElement('img');
    img.setAttribute('src', thumbUrl);
    img.setAttribute('alt', 'Transitions');
    img.setAttribute('loading', 'lazy');
    imageWrap.appendChild(img);

    var contentBox = btn.querySelector('.la-label-content-box');
    if (contentBox) {
      btn.insertBefore(imageWrap, contentBox);
    } else {
      btn.insertBefore(imageWrap, btn.firstChild);
    }
  }

  function ensureTransitionsLogo(btn) {
    if (!btn) return;

    if (!isLensTypeStepBtn(btn)) {
      btn.classList.remove('ciw-la-lens-card--transitions');
      restoreTransitionsCardChrome(btn);
      removeInjectedTransitionsThumb(btn);
      var removedLogo = btn.querySelector('.ciw-la-transitions-logo');
      if (removedLogo) removedLogo.remove();
      return;
    }

    if (!isTransitionsLensType(btn)) {
      btn.classList.remove('ciw-la-lens-card--transitions');
      restoreTransitionsCardChrome(btn);
      removeInjectedTransitionsThumb(btn);
      var existingLogo = btn.querySelector('.ciw-la-transitions-logo');
      if (existingLogo) existingLogo.remove();
      return;
    }

    btn.classList.add('ciw-la-lens-card--transitions');

    ensureTransitionsLensThumbnail(btn);

    var title = btn.querySelector('.la-label-title');
    if (!title) return;

    var logoWrap = title.querySelector('.ciw-la-transitions-logo');
    if (!logoWrap) {
      logoWrap = document.createElement('span');
      logoWrap.className = 'ciw-la-transitions-logo';
      logoWrap.setAttribute('aria-hidden', 'true');
      title.insertBefore(logoWrap, title.firstChild);
    }

    var existingSvg = logoWrap.querySelector('svg');
    if (!existingSvg || existingSvg.getAttribute('viewBox') !== GUSA_TRANSITIONS_LOGO_VIEWBOX) {
      logoWrap.textContent = '';
      logoWrap.appendChild(buildGusaTransitionsLogoSvg());
    }

    title.querySelectorAll('la-translate').forEach(function (node) {
      node.classList.add('ciw-la-transitions-title-hidden');
      node.setAttribute('aria-hidden', 'true');
    });

    syncTransitionsDescriptionSpacing(btn);
  }

  function isTransitionTypeStepBtn(btn) {
    return !!btn.closest('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)');
  }

  function isLikelyTransitionTypeName(label) {
    var normalized = String(label || '')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' - ')[0];
    if (!normalized || isLikelyThicknessTierName(normalized)) return false;
    return /gen\s*s|photochromic|xtr\s*active|xtractive|\btransitions?\b/i.test(normalized);
  }

  function countLensOptionCards(scope) {
    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    var tierCount = 0;
    var typeCount = 0;
    var colorCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
      if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      else if (isLikelyTransitionTypeName(cardTitle)) typeCount++;
      else if (isLikelyLensColorCardName(cardTitle)) colorCount++;
    }
    return { wrappers: wrappers.length, tierCount: tierCount, typeCount: typeCount, colorCount: colorCount };
  }

  function getSelectedUsageLabel() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      if (selected && selected.title) {
        if (la.Translation && typeof la.Translation.getTranslatedText === 'function') {
          return String(la.Translation.getTranslatedText(selected.title) || selected.title)
            .replace(/\s+/g, ' ')
            .trim();
        }
        return String(selected.title).replace(/\s+/g, ' ').trim();
      }
    }
    return '';
  }

  function isProgressivePrescriptionFlow() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      var text = '';
      if (typeof selected === 'string') {
        text = selected;
      } else if (selected) {
        text = [selected.title, selected.name, selected.type, selected.handle].filter(Boolean).join(' ');
      }
      if (/progressive/i.test(text)) return true;
    }
    return /progressive/i.test(getSelectedUsageLabel());
  }

  function isLikelyProgressiveTypeCardName(name) {
    var label = String(name || '')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' - ')[0];
    if (
      !label ||
      isLikelyThicknessTierName(label) ||
      isLikelyTransitionTypeName(label) ||
      isLikelyLensColorCardName(label) ||
      isSunglassesLensTypeTitle(label)
    ) {
      return false;
    }
    return true;
  }

  function isProgressiveTypeOptionsStepScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;
    if (!isProgressivePrescriptionFlow()) return false;
    /* Solid/Gradient/Polarized sunglasses picker is not "Choose progressive type". */
    if (isSunglassesLensSelectionScope(scope)) return false;
    if (scope.classList.contains('ciw-la-progressive-type-options-step')) return true;
    var counts = countLensOptionCards(scope);
    return counts.wrappers >= 3 && counts.tierCount === 0 && counts.colorCount === 0 && counts.typeCount === 0;
  }

  function isProgressiveTypeStepScope(scope) {
    if (!scope) return false;
    /* Progressive + Sunglasses tint step shares la-render-lenses + 3 non-tier cards.
       Without this gate, layoutProgressiveTypeCard injects an empty title-row and
       pulls swatches off the right edge. */
    if (isSunglassesLensSelectionScope(scope)) return false;
    if (scope.classList.contains('la-render-options')) {
      return isProgressiveTypeOptionsStepScope(scope);
    }
    if (!scope.classList.contains('la-render-lenses') || scope.classList.contains('x-pro')) {
      return false;
    }
    if (!isProgressivePrescriptionFlow() || isTransitionsLensFlow()) return false;
    var counts = countLensOptionCards(scope);
    return counts.wrappers >= 3 && counts.tierCount === 0 && counts.colorCount === 0 && counts.typeCount === 0;
  }

  function isProgressiveTypeStepBtn(btn) {
    if (!btn) return false;
    var scope =
      btn.closest('.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step.la-render-options') ||
      btn.closest('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)');
    return scope ? isProgressiveTypeStepScope(scope) : false;
  }

  function isProgressiveTypeCard(btn) {
    if (!btn || !isProgressiveTypeStepBtn(btn)) return false;
    return isLikelyProgressiveTypeCardName(getCardTitleText(btn));
  }

  function getProgressiveTypeCardImageUrl(btn) {
    var title = getCardTitleText(btn).split(' - ')[0];
    if (!title) return '';

    var la = window.LensAdvizor;
    if (!la) return '';

    var candidates = [];
    if (la.lenses && typeof la.lenses === 'object') {
      Object.keys(la.lenses).forEach(function (key) {
        candidates.push(la.lenses[key]);
      });
    }
    if (Array.isArray(la.lensOptions)) {
      candidates = candidates.concat(la.lensOptions);
    }

    var i;
    for (i = 0; i < candidates.length; i++) {
      var lens = candidates[i];
      if (!lens) continue;
      var name = String(lens.name || lens.title || lens.label || '')
        .replace(/\s+/g, ' ')
        .trim();
      if (!name) continue;
      var shortName = name.split(' - ')[0];
      if (shortName !== title && name.indexOf(title) !== 0 && title.indexOf(shortName) !== 0) continue;
      var url = lens.image || lens.image_url || lens.icon || lens.logo || lens.thumbnail || '';
      if (typeof url === 'string' && url) return url;
      if (url && url.src) return url.src;
    }

    return '';
  }

  function extractProgressiveTypeTitleLogo(title) {
    if (!title) return null;

    var directWrap = title.querySelector(':scope > .la-label-image-wapper, :scope > .la-label-image');
    if (directWrap) {
      directWrap.remove();
      var normalizedWrap = normalizeIconWrap(directWrap);
      if (normalizedWrap && iconWrapHasVisual(normalizedWrap)) return normalizedWrap;
    }

    var picture = title.querySelector(':scope > picture');
    if (picture) {
      picture.remove();
      var pictureWrap = document.createElement('span');
      pictureWrap.className = 'la-label-image';
      pictureWrap.appendChild(picture);
      return pictureWrap;
    }

    var img = title.querySelector(':scope > img');
    if (img) {
      img.remove();
      var imgWrap = document.createElement('span');
      imgWrap.className = 'la-label-image';
      imgWrap.appendChild(img);
      return imgWrap;
    }

    var svg = title.querySelector(':scope > svg');
    if (svg) {
      svg.remove();
      var svgWrap = document.createElement('span');
      svgWrap.className = 'la-label-image';
      svgWrap.appendChild(svg);
      return svgWrap;
    }

    return null;
  }

  function layoutProgressiveTypeCard(btn) {
    if (!btn) return;

    if (isSunglassesLensSelectionBtn(btn) || isSunglassesLensTypeTitle(getCardTitleText(btn))) {
      btn.classList.remove('ciw-la-lens-card--progressive-type', 'ciw-la-lens-card--has-icon');
      return;
    }

    if (!isProgressiveTypeCard(btn)) {
      btn.classList.remove('ciw-la-lens-card--progressive-type', 'ciw-la-lens-card--has-icon');
      return;
    }

    if (
      btn.classList.contains('ciw-la-lens-card--progressive-type') &&
      btn.classList.contains('ciw-la-lens-card--ready') &&
      btn.querySelector('.ciw-la-lens-card-head')
    ) {
      return;
    }

    undoLensLayoutIfNeeded(btn);

    var title = btn.querySelector('.la-label-title');
    var description = btn.querySelector('.la-label-description');
    if (!title) return;

    var titleLogoWrap = extractProgressiveTypeTitleLogo(title);

    var contentBox = btn.querySelector('.la-label-content-box');
    if (!contentBox) {
      contentBox = document.createElement('div');
      contentBox.className = 'la-label-content-box';
    }

    if (title.parentNode !== contentBox) {
      contentBox.appendChild(title);
    }
    if (description && description.parentNode !== contentBox) {
      contentBox.appendChild(description);
    }

    var iconWrap =
      normalizeIconWrap(
        btn.querySelector(':scope > .la-label-image-wapper, :scope > .la-label-image')
      ) ||
      normalizeIconWrap(findIconWrap(btn)) ||
      titleLogoWrap;

    if (!iconWrap || !iconWrapHasVisual(iconWrap)) {
      var imageUrl = getProgressiveTypeCardImageUrl(btn);
      if (imageUrl) {
        if (!iconWrap) {
          iconWrap = document.createElement('span');
          iconWrap.className = 'la-label-image';
        }
        var img = iconWrap.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.setAttribute('alt', '');
          img.setAttribute('aria-hidden', 'true');
          iconWrap.appendChild(img);
        }
        if (img.getAttribute('src') !== imageUrl) {
          img.setAttribute('src', imageUrl);
        }
      }
    }

    if (iconWrap) {
      if (iconWrap.parentNode !== btn) {
        btn.insertBefore(iconWrap, btn.firstChild);
      }
      btn.classList.add('ciw-la-lens-card--has-icon');
    } else {
      btn.classList.remove('ciw-la-lens-card--has-icon');
    }

    var cardHead = btn.querySelector('.ciw-la-lens-card-head');
    if (!cardHead) {
      cardHead = document.createElement('div');
      cardHead.className = 'ciw-la-lens-card-head';
    }

    var titleRow = cardHead.querySelector('.ciw-la-lens-card-title-row');
    if (!titleRow) {
      titleRow = document.createElement('div');
      titleRow.className = 'ciw-la-lens-card-title-row';
      cardHead.appendChild(titleRow);
    }

    if (title && title.parentNode !== titleRow) {
      titleRow.appendChild(title);
    }

    if (isMobileViewport()) {
      if (iconWrap && iconWrap.parentNode === btn) {
        iconWrap.remove();
      }
      cardHead.querySelectorAll(':scope > .la-label-image, :scope > .la-label-image-wapper').forEach(function (node) {
        node.remove();
      });
      btn.classList.remove('ciw-la-lens-card--has-icon');
    } else if (iconWrap) {
      if (iconWrap.parentNode !== cardHead) {
        cardHead.insertBefore(iconWrap, titleRow);
      }
      btn.classList.add('ciw-la-lens-card--has-icon');
    } else {
      btn.classList.remove('ciw-la-lens-card--has-icon');
    }

    if (cardHead.parentNode !== btn) {
      btn.insertBefore(cardHead, btn.firstChild);
    }

    btn.querySelectorAll(':scope > .la-label-image, :scope > .la-label-image-wapper').forEach(function (node) {
      node.remove();
    });

    if (description) {
      if (description.parentNode !== btn) {
        cardHead.insertAdjacentElement('afterend', description);
      } else if (description.previousElementSibling !== cardHead) {
        cardHead.insertAdjacentElement('afterend', description);
      }
    }

    if (contentBox && contentBox.parentNode === btn) {
      contentBox.remove();
    }
    btn.querySelectorAll(':scope > .la-label-content-box').forEach(function (box) {
      box.remove();
    });

    pinPriceToCard(btn, cardHead);

    markBasicCard(btn);
    btn.classList.add('ciw-la-lens-card--progressive-type', 'ciw-la-lens-card--ready');
  }

  function isTransitionsGenSCard(btn) {
    var label = getCardTitleText(btn);
    if (!label || !isLikelyTransitionTypeName(label)) return false;
    if (/xtr\s*active|xtractive/i.test(label)) return false;
    if (/^photocromic\b/i.test(label)) return false;
    return /gen\s*s/i.test(label);
  }

  function isTransitionsXTRActiveCard(btn) {
    var label = getCardTitleText(btn);
    if (!label || !isLikelyTransitionTypeName(label)) return false;
    return /xtr\s*active|xtractive/i.test(label);
  }

  function isTransitionsXTRPolarizedCard(btn) {
    var label = getCardTitleText(btn);
    if (!label || !isLikelyTransitionTypeName(label)) return false;
    return /xtr\s*active|xtractive/i.test(label) && /polari[sz]ed/i.test(label);
  }

  function isPhotocromicTransitionTypeCard(btn) {
    var label = getCardTitleText(btn);
    if (!label) return false;
    if (/gen\s*s|xtr\s*active|xtractive|\btransitions?\b/i.test(label)) return false;
    return /^photocromic\b|^photochromic\b/i.test(label);
  }

  var GUSA_TRANSITIONS_GEN_S_VIEWBOX = '0 0 301 79';

  var GUSA_TRANSITIONS_GEN_S_PATHS = [
    {
      d:
        'M251.922 6.118c-7.455 1.21-11.987 5.728-12.911 9.175-1.084 4.047-.542 7.527 2.281 10.865 3.004 3.553 8.77 7.152 18.709 10.593 10.273 3.556 17.232 7.584 21.248 12.334 4.199 4.966 4.974 10.468 3.457 16.128-1.677 6.26-8.568 11.947-17.599 13.412-9.261 1.503-20.89-1.318-32.844-12l3.877-4.338c10.893 9.733 20.811 11.767 28.035 10.595 7.455-1.21 11.988-5.728 12.911-9.175 1.085-4.047.543-7.527-2.28-10.865-3.004-3.553-8.77-7.152-18.709-10.593-10.274-3.556-17.232-7.584-21.249-12.334-4.198-4.966-4.973-10.468-3.457-16.128C235.069 7.527 241.96 1.84 250.99.375c9.261-1.503 20.891 1.318 32.845 12l-3.877 4.338C269.065 6.98 259.147 4.946 251.922 6.118m35.858-3.43h1.8l.054 4.95h1.404V2.733h1.8V1.5h-5.058zm7.776-1.233h-1.476v6.138h1.323v-4.15l1.692 2.7h.117l1.701-2.7v4.15h1.314V1.455h-1.44l-1.611 2.592zM37.436 78.35c5.958-1.01 11.28-3.517 16.104-7.252q.178-.148.34-.286a7 7 0 0 1 .657-.52c.554-.37.692-.86.69-1.51-.016-6.053-.015-12.106-.014-18.159v-5.732H30.12v5.04h19.843v1.103l-.003 3.874c-.005 3.799-.01 7.597.026 11.395.008.89-.284 1.418-.994 1.912-7.136 4.972-14.958 6.92-23.524 5.137-7.241-1.507-12.706-5.571-15.976-12.247C5.91 53.8 5.508 46.16 7.925 38.43c1.72-5.5 4.998-9.956 9.81-13.192 4.571-3.076 9.637-4.2 15.122-3.836 6.25.414 11.678 2.67 16.342 6.822.107.095.22.183.348.282q.097.074.204.16l3.535-4.056c-2.421-2.063-4.95-3.817-7.737-5.188-3.576-1.759-7.376-2.69-11.333-2.961-3.688-.252-7.364-.163-10.968.803-8.744 2.342-14.973 7.76-18.935 15.783-4.06 8.22-4.482 16.804-1.816 25.498 2.265 7.389 6.794 13.07 13.665 16.735 6.707 3.577 13.87 4.325 21.274 3.07m43.826-59.265c-7.166 3.528-11.859 9.266-14.625 16.759-2.218 6.384-2.58 12.826-1.234 19.353 1.24 6.02 3.976 11.279 8.395 15.584 4.942 4.814 10.876 7.536 17.77 8.086 5.378.43 10.582-.312 15.548-2.483 4.247-1.856 7.777-4.703 10.956-8.022.128-.134.247-.275.375-.427l.196-.23-3.987-3.517-.541.556-.003.004h-.001c-.368.38-.719.743-1.083 1.09-6.029 5.767-13.167 8.426-21.51 7.56-5.143-.532-9.585-2.66-13.29-6.262-3.845-3.737-6.042-8.35-7.016-13.577-.142-.76-.238-1.529-.34-2.336q-.07-.576-.153-1.184h49.555l.022-.18.017-.135c.025-.197.046-.362.061-.528l.01-.107c.023-.244.046-.49.046-.734.005-4.395-.509-8.715-1.909-12.903-1.655-4.948-4.263-9.29-8.214-12.752-4.121-3.612-8.948-5.586-14.39-6.13-5.123-.513-10.037.24-14.655 2.514m8.61 2.853c7.373-.93 13.7 1.165 18.559 7.013 3.699 4.713 5.256 10.055 5.756 15.87H70.774q.037-.332.07-.663c.048-.477.096-.954.168-1.427.762-5.008 2.603-9.556 5.89-13.452 3.409-4.043 7.695-6.676 12.97-7.341m39.821 37.96V17.881h5.775v10.617l.156.084.164-.251q.176-.269.348-.539c2.181-3.468 4.944-6.343 8.54-8.366 3.013-1.694 6.262-2.591 9.697-2.887 3.936-.34 7.808-.027 11.545 1.275 7.353 2.561 11.868 7.778 13.966 15.19.754 2.662 1.032 5.39 1.034 8.147q.006 12.993.004 25.986l-.001 9.526v.864h-5.752v-1.026l.001-9.408v-.04q.005-12.33-.005-24.659c-.003-3.298-.406-6.539-1.641-9.63-2.401-6.01-6.844-9.54-13.169-10.688-4.471-.81-8.854-.407-12.997 1.526-6.095 2.843-9.768 7.68-11.312 14.177-.42 1.766-.577 3.568-.576 5.387q.007 12.47.005 24.94l-.001 8.324v1.083h-5.781zm77.978-18.453c-.454 0-.95.002-1.469.004-1.775.005-3.821.012-5.373-.007-3.241-.039-5.923-1.975-6.794-4.952-.833-2.851-.128-5.349 2.091-7.295 2.194-1.925 4.766-2.296 7.42-1.1 2.653 1.194 4.038 3.357 4.116 6.281.035 1.29.025 3.363.016 5.138-.003.716-.007 1.383-.007 1.93m15.114-11.501a292 292 0 0 1-.009 4.491c-.038 3.22-2.08 5.926-5.15 6.732-2.787.732-5.22-.007-7.102-2.173-1.859-2.139-2.249-4.641-1.148-7.249 1.117-2.644 3.205-4.114 6.082-4.25 1.573-.075 3.15-.059 4.727-.042q.985.012 1.969.014l.098-.003c.253-.008.525-.017.528.474l.005 1.992zM215.496 56.7a6.996 6.996 0 0 0 7.163-5.802c.634-4.426-2.549-8.142-6.919-8.161-2.039-.01-4.882-.004-6.92 0a819 819 0 0 0 .005 7.183c.046 3.626 3.045 6.656 6.671 6.78m-11.951-.594a7.014 7.014 0 0 1-9.541-4.433c-1.279-4.39 1.989-8.874 6.563-8.928 2.327-.027 7.115-.017 7.115 0 .002.754.001 1.624 0 2.52v.005c-.002 1.414-.004 2.892.006 4.08.028 3.088-1.331 5.324-4.143 6.756',
      fill: '#0f0f0f',
      fillRule: 'evenodd',
    },
  ];

  var GUSA_TRANSITIONS_XTR_ACTIVE_VIEWBOX = '0 0 80 10';

  var GUSA_TRANSITIONS_XTR_ACTIVE_PATHS = [
    {
      d:
        'M51.153.687h-4.138l-3.184.02v1.038h3.024v7.558h1.133V1.744h3.165zM38.74.63c-.672.105-1.55.586-1.966 1.059-1.681 1.965-1.445 5.593.472 7.057.624.472 1.248.67 2.079.67 1.275-.009 2.23-.557 2.777-1.596.492-.935.492-.926-.141-1.247l-.567-.283-.113.425c-.18.633-.605 1.228-1.03 1.445-.841.435-1.606.34-2.305-.274C36.5 6.611 36.5 3.4 37.936 2.133c.67-.586 1.493-.709 2.22-.33.369.188.888.821 1.03 1.265.066.208.142.378.151.378.151 0 .983-.614.983-.718 0-.274-.397-.916-.813-1.323-.67-.652-1.72-.944-2.768-.774ZM6.797 2.454 5.05 4.202l-1.72-1.72L1.601.754l-.396.406-.407.397 1.73 1.728 1.719 1.72-1.7 1.7C1.61 7.641.845 8.453.845 8.5c0 .057.16.265.359.454l.359.35L3.17 7.696c.878-.888 1.672-1.662 1.776-1.71.15-.094.397.114 1.89 1.606l1.719 1.71.396-.406.397-.397-1.7-1.7c-.936-.935-1.7-1.738-1.7-1.795 0-.047.651-.737 1.445-1.53.784-.785 1.55-1.55 1.69-1.701l.265-.274-.406-.397-.397-.397-1.748 1.748Zm3.591-1.228v.52h3.022v7.558h1.228v-7.56h3.024V.706h-7.274zm8.88 3.769v4.308h1.134V5.505l1.35.038c1.238.029 1.37.048 1.664.255.387.284.633.822.718 1.569.084.812.236 1.474.387 1.72.123.198.208.216.888.216.416 0 .756-.028.756-.056 0-.029-.104-.142-.227-.236-.265-.208-.576-.964-.67-1.644-.17-1.134-.568-1.843-1.21-2.126l-.378-.17.378-.104c.897-.246 1.54-1.02 1.54-1.861 0-1.04-.482-1.738-1.464-2.116-.52-.199-.756-.227-2.712-.265L19.268.687zm4.544-2.985c.406.246.605.661.595 1.228-.009.5-.245.85-.755 1.106-.312.16-.596.198-1.805.217l-1.445.038V1.727l1.54.037c1.398.029 1.558.048 1.87.246M29.991.82c-.16.415-2.787 8.351-2.787 8.408 0 .047.255.075.558.075h.557l.425-1.256.416-1.247h3.098l.416 1.247.416 1.256h.595c.33 0 .605-.028.605-.075 0-.038-.633-1.956-1.398-4.27L31.483.754l-.718-.029c-.53-.019-.747.01-.775.095Zm1.351 3.08c.321.973.586 1.804.586 1.842s-.558.066-1.238.066c-1.077 0-1.228-.019-1.18-.142.028-.085.292-.916.595-1.842.292-.935.557-1.7.595-1.7.028 0 .311.802.642 1.776m21.37-2.674v.52h2.456v6.519h-2.456v1.038h6.046v-1.04h-2.362V1.746h2.362V.705h-6.046zM60.573.82c.028.066.67 2.002 1.436 4.308l1.398 4.185.718-.028.709-.029 1.407-4.204C67.007 2.737 67.64.82 67.64.782c0-.047-.265-.076-.586-.076h-.595l-1.087 3.449c-1.077 3.41-1.18 3.722-1.256 3.637-.02-.029-.548-1.625-1.162-3.543L61.83.753l-.652-.028c-.501-.019-.633 0-.605.095m9.239 4.185v4.298h5.669V8.264h-4.44V5.336h3.125l-.028-.501-.028-.491-1.53-.029-1.54-.019v-2.55h4.345V.706h-5.574v4.299Zm7.7-4.166c-.642.274-.973.973-.87 1.776.067.51.313.831.842 1.096.595.302 1.03.217 1.559-.303q.736-.736.368-1.7c-.18-.482-.359-.652-.84-.86-.416-.17-.681-.18-1.059-.01Zm1.19.274c.964.642.785 2.21-.283 2.531-.5.152-.822.048-1.257-.377-.33-.34-.359-.407-.359-.907 0-.652.227-1.087.69-1.314.425-.207.832-.189 1.21.067Z',
      fill: '#0f0f0f',
    },
    {
      d:
        'M77.464 2.265c0 .652.029.803.142.803q.142 0 .142-.283c0-.218.047-.284.18-.284.103 0 .264.123.358.284.085.15.246.283.34.283.161 0 .161-.019-.028-.293-.189-.264-.198-.293-.057-.453.388-.425.076-.86-.614-.86h-.463zm1.011-.368c.076.198-.198.415-.51.415-.18 0-.217-.047-.217-.283 0-.265.028-.284.33-.284.227 0 .36.048.397.152',
      fill: '#0f0f0f',
    },
  ];

  function buildGusaLogoSvgFromPaths(viewBox, paths) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('viewBox', viewBox);
    svg.setAttribute('aria-hidden', 'true');
    paths.forEach(function (pathData) {
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('fill', pathData.fill || '#393939');
      path.setAttribute('d', pathData.d);
      if (pathData.fillRule) {
        path.setAttribute('fill-rule', pathData.fillRule);
        path.setAttribute('clip-rule', pathData.fillRule);
      }
      svg.appendChild(path);
    });
    return svg;
  }

  function buildGusaTransitionsGenSLogoSvg() {
    return buildGusaLogoSvgFromPaths(GUSA_TRANSITIONS_GEN_S_VIEWBOX, GUSA_TRANSITIONS_GEN_S_PATHS);
  }

  function buildGusaTransitionsXTRActiveBadgeSvg() {
    return buildGusaLogoSvgFromPaths(GUSA_TRANSITIONS_XTR_ACTIVE_VIEWBOX, GUSA_TRANSITIONS_XTR_ACTIVE_PATHS);
  }

  var XTR_POLARIZED_BADGE_CLASS = 'ciw-la-transitions-xtr-polarized-badge';

  var GUSA_TRANSITIONS_XTR_POLARIZED_VIEWBOX = '0 0 401.95 72.75';

  var GUSA_TRANSITIONS_XTR_POLARIZED_PATHS = [
    {
      d:
        'M9.47 71.58L0 71.58L0 0L27 0Q34.13 0 37.89 0.68Q43.16 1.56 46.73 4.03Q50.29 6.49 52.47 10.94Q54.64 15.38 54.64 20.70Q54.64 29.83 48.83 36.16Q43.02 42.48 27.83 42.48L9.47 42.48L9.47 71.58M9.47 8.45L9.47 34.03L27.98 34.03Q37.16 34.03 41.02 30.62Q44.87 27.20 44.87 21Q44.87 16.50 42.60 13.31Q40.33 10.11 36.62 9.08Q34.23 8.45 27.78 8.45L9.47 8.45M62.30 45.65Q62.30 31.25 70.31 24.32Q77 18.55 86.62 18.55Q97.31 18.55 104.10 25.56Q110.89 32.57 110.89 44.92Q110.89 54.93 107.89 60.67Q104.88 66.41 99.15 69.58Q93.41 72.75 86.62 72.75Q75.73 72.75 69.02 65.77Q62.30 58.79 62.30 45.65M71.34 45.65Q71.34 55.62 75.68 60.57Q80.03 65.53 86.62 65.53Q93.16 65.53 97.51 60.55Q101.86 55.57 101.86 45.36Q101.86 35.74 97.49 30.79Q93.12 25.83 86.62 25.83Q80.03 25.83 75.68 30.76Q71.34 35.69 71.34 45.65M129.79 71.58L121 71.58L121 0L129.79 0L129.79 71.58M177.25 65.19Q172.36 69.34 167.85 71.04Q163.33 72.75 158.15 72.75Q149.61 72.75 145.02 68.58Q140.43 64.40 140.43 57.91Q140.43 54.10 142.16 50.95Q143.90 47.80 146.70 45.90Q149.51 43.99 153.03 43.02Q155.62 42.33 160.84 41.70Q171.48 40.43 176.51 38.67Q176.56 36.87 176.56 36.38Q176.56 31.01 174.07 28.81Q170.70 25.83 164.06 25.83Q157.86 25.83 154.91 28Q151.95 30.18 150.54 35.69L141.94 34.52Q143.12 29 145.80 25.61Q148.49 22.22 153.56 20.39Q158.64 18.55 165.33 18.55Q171.97 18.55 176.12 20.12Q180.27 21.68 182.23 24.05Q184.18 26.42 184.96 30.03Q185.40 32.28 185.40 38.13L185.40 49.85Q185.40 62.11 185.96 65.36Q186.52 68.60 188.18 71.58L179 71.58Q177.64 68.85 177.25 65.19M176.51 48.78L176.51 45.56Q171.73 47.51 162.16 48.88Q156.74 49.66 154.49 50.63Q152.25 51.61 151.03 53.49Q149.80 55.37 149.80 57.67Q149.80 61.18 152.47 63.53Q155.13 65.87 160.25 65.87Q165.33 65.87 169.29 63.65Q173.24 61.43 175.10 57.57Q176.51 54.59 176.51 48.78M207.71 71.58L198.93 71.58L198.93 19.73L206.84 19.73L206.84 27.59Q209.86 22.07 212.43 20.31Q214.99 18.55 218.07 18.55Q222.51 18.55 227.10 21.39L224.07 29.54Q220.85 27.64 217.63 27.64Q214.75 27.64 212.45 29.37Q210.16 31.10 209.18 34.18Q207.71 38.87 207.71 44.43L207.71 71.58M241.16 10.11L232.37 10.11L232.37 0L241.16 0L241.16 10.11M241.16 71.58L232.37 71.58L232.37 19.73L241.16 19.73L241.16 71.58M295.80 71.58L249.90 71.58L249.90 64.45L282.91 26.56Q277.29 26.86 273 26.86L251.86 26.86L251.86 19.73L294.24 19.73L294.24 25.54L266.16 58.45L260.74 64.45Q266.65 64.01 271.83 64.01L295.80 64.01L295.80 71.58M340.04 54.88L349.12 56.01Q346.97 63.96 341.16 68.36Q335.35 72.75 326.32 72.75Q314.94 72.75 308.28 65.75Q301.61 58.74 301.61 46.09Q301.61 33.01 308.35 25.78Q315.09 18.55 325.83 18.55Q336.23 18.55 342.82 25.63Q349.41 32.71 349.41 45.56Q349.41 46.34 349.37 47.90L310.69 47.90Q311.18 56.45 315.53 60.99Q319.87 65.53 326.37 65.53Q331.20 65.53 334.62 62.99Q338.04 60.45 340.04 54.88M311.18 40.67L340.14 40.67Q339.55 34.13 336.82 30.86Q332.62 25.78 325.93 25.78Q319.87 25.78 315.75 29.83Q311.62 33.89 311.18 40.67M401.95 71.58L393.80 71.58L393.80 65.04Q388.87 72.75 379.30 72.75Q373.10 72.75 367.90 69.34Q362.70 65.92 359.84 59.79Q356.98 53.66 356.98 45.70Q356.98 37.94 359.57 31.62Q362.16 25.29 367.33 21.92Q372.51 18.55 378.91 18.55Q383.59 18.55 387.26 20.53Q390.92 22.51 393.21 25.68L393.21 0L401.95 0L401.95 71.58M366.02 45.70Q366.02 55.66 370.21 60.60Q374.41 65.53 380.13 65.53Q385.89 65.53 389.92 60.82Q393.95 56.10 393.95 46.44Q393.95 35.79 389.84 30.81Q385.74 25.83 379.74 25.83Q373.88 25.83 369.95 30.62Q366.02 35.40 366.02 45.70',
      fill: '#0f0f0f',
    },
  ];

  function buildGusaTransitionsXTRPolarizedBadgeSvg() {
    return buildGusaLogoSvgFromPaths(
      GUSA_TRANSITIONS_XTR_POLARIZED_VIEWBOX,
      GUSA_TRANSITIONS_XTR_POLARIZED_PATHS
    );
  }

  function restoreTransitionTypeTitleText(btn) {
    if (!btn) return;
    var title = btn.querySelector('.la-label-title');
    if (!title) return;
    title.querySelectorAll('la-translate.ciw-la-transitions-title-hidden').forEach(function (node) {
      node.classList.remove('ciw-la-transitions-title-hidden');
      node.removeAttribute('aria-hidden');
    });
  }

  function removeTransitionTypeLogos(btn) {
    if (!btn) return;
    var gensLogo = btn.querySelector('.ciw-la-transitions-gens-logo');
    if (gensLogo) gensLogo.remove();
    var xtrLogo = btn.querySelector('.ciw-la-transitions-xtr-logo');
    if (xtrLogo) xtrLogo.remove();
  }

  function hideTransitionTypeTitleText(title) {
    if (!title) return;
    title.querySelectorAll('la-translate').forEach(function (node) {
      node.classList.add('ciw-la-transitions-title-hidden');
      node.setAttribute('aria-hidden', 'true');
    });
  }

  function ensureTransitionTypeBrandLogo(btn, config) {
    var title = btn.querySelector('.la-label-title');
    if (!title) return;

    var logoWrap = title.querySelector('.' + config.wrapClass);
    if (!logoWrap) {
      logoWrap = document.createElement('span');
      logoWrap.className = config.wrapClass;
      logoWrap.setAttribute('aria-hidden', 'true');
      title.insertBefore(logoWrap, title.firstChild);
    }

    var wordmark = logoWrap.querySelector('.' + config.wordmarkClass);
    if (!wordmark) {
      wordmark = document.createElement('span');
      wordmark.className = config.wordmarkClass;
      logoWrap.appendChild(wordmark);
    }

    var badge = logoWrap.querySelector('.' + config.badgeClass);
    if (!badge) {
      badge = document.createElement('span');
      badge.className = config.badgeClass;
      logoWrap.appendChild(badge);
    }

    logoWrap.querySelectorAll(':scope > svg').forEach(function (node) {
      node.remove();
    });

    var existingWordmark = wordmark.querySelector('svg');
    if (!existingWordmark || existingWordmark.getAttribute('viewBox') !== GUSA_TRANSITIONS_LOGO_VIEWBOX) {
      wordmark.textContent = '';
      wordmark.appendChild(buildGusaTransitionsLogoSvg());
    }

    var existingBadge = badge.querySelector('svg');
    if (!existingBadge || existingBadge.getAttribute('viewBox') !== config.badgeViewBox) {
      badge.textContent = '';
      badge.appendChild(config.buildBadgeSvg());
    }

    if (config.buildExtraBadgeSvg) {
      var extraBadge = logoWrap.querySelector('.' + config.extraBadgeClass);
      if (!extraBadge) {
        extraBadge = document.createElement('span');
        extraBadge.className = config.extraBadgeClass;
        logoWrap.appendChild(extraBadge);
      }
      var existingExtra = extraBadge.querySelector('svg');
      if (!existingExtra || existingExtra.getAttribute('viewBox') !== config.extraBadgeViewBox) {
        extraBadge.textContent = '';
        extraBadge.appendChild(config.buildExtraBadgeSvg());
      }
    } else {
      var staleExtra = logoWrap.querySelector('.' + XTR_POLARIZED_BADGE_CLASS);
      if (staleExtra) staleExtra.remove();
    }

    hideTransitionTypeTitleText(title);
    btn.classList.add(config.cardClass);
  }

  var PHOTOCHROMIC_CARD_DESCRIPTION =
    'The affordable light-adaptive lens — clear indoors, dark in the sun, full UV protection.';

  var TRANSITIONS_GEN_S_CARD_DESCRIPTION =
    'The fastest everyday Transitions lens — clear indoors, sunglass-dark outside, and back to clear in seconds.';

  var TRANSITIONS_XTR_ACTIVE_CARD_DESCRIPTION =
    'The darkest Transitions lens — and the only one that goes dark inside your car. Built for people sensitive to bright light, indoors, outdoors, and behind the wheel.';

  function ensureTransitionTypeGenSLogo(btn) {
    ensureTransitionTypeBrandLogo(btn, {
      wrapClass: 'ciw-la-transitions-gens-logo',
      wordmarkClass: 'ciw-la-transitions-gens-wordmark',
      badgeClass: 'ciw-la-transitions-gens-badge',
      cardClass: 'ciw-la-lens-card--transitions-gens',
      badgeViewBox: GUSA_TRANSITIONS_GEN_S_VIEWBOX,
      buildBadgeSvg: buildGusaTransitionsGenSLogoSvg,
    });
    ensureTransitionTypeCardDescription(btn, TRANSITIONS_GEN_S_CARD_DESCRIPTION, 'gens');
  }

  function ensureTransitionTypeXTRLogo(btn) {
    ensureTransitionTypeBrandLogo(btn, {
      wrapClass: 'ciw-la-transitions-xtr-logo',
      wordmarkClass: 'ciw-la-transitions-xtr-wordmark',
      badgeClass: 'ciw-la-transitions-xtr-badge',
      cardClass: 'ciw-la-lens-card--transitions-xtr',
      badgeViewBox: GUSA_TRANSITIONS_XTR_ACTIVE_VIEWBOX,
      buildBadgeSvg: buildGusaTransitionsXTRActiveBadgeSvg,
    });
    ensureTransitionTypeCardDescription(btn, TRANSITIONS_XTR_ACTIVE_CARD_DESCRIPTION, 'xtr');
  }

  function ensureTransitionTypeXTRPolarizedLogo(btn) {
    ensureTransitionTypeBrandLogo(btn, {
      wrapClass: 'ciw-la-transitions-xtr-logo',
      wordmarkClass: 'ciw-la-transitions-xtr-wordmark',
      badgeClass: 'ciw-la-transitions-xtr-badge',
      cardClass: 'ciw-la-lens-card--transitions-xtr',
      badgeViewBox: GUSA_TRANSITIONS_XTR_ACTIVE_VIEWBOX,
      buildBadgeSvg: buildGusaTransitionsXTRActiveBadgeSvg,
      extraBadgeClass: XTR_POLARIZED_BADGE_CLASS,
      extraBadgeViewBox: GUSA_TRANSITIONS_XTR_POLARIZED_VIEWBOX,
      buildExtraBadgeSvg: buildGusaTransitionsXTRPolarizedBadgeSvg,
    });
    ensureTransitionTypeCardDescription(btn, TRANSITIONS_XTR_ACTIVE_CARD_DESCRIPTION, 'xtr');
  }

  function ensureTransitionTypeCardDescription(btn, text, type) {
    if (!btn || !text) return;

    var description = btn.querySelector('.la-label-description');
    if (!description) {
      description = document.createElement('div');
      description.className = 'la-label-description';
      var head = btn.querySelector('.ciw-la-lens-card-head');
      if (head) {
        head.insertAdjacentElement('afterend', description);
      } else {
        var titleRow = btn.querySelector('.ciw-la-lens-card-title-row') || btn.querySelector('.la-label-title');
        if (titleRow && titleRow.parentNode) {
          titleRow.parentNode.insertAdjacentElement('afterend', description);
        } else {
          btn.appendChild(description);
        }
      }
    }

    description.setAttribute('data-ciw-la-transition-desc', type || 'xtr');

    var translate = description.querySelector('la-translate');
    if (!translate) {
      translate = document.createElement('la-translate');
      description.textContent = '';
      description.appendChild(translate);
    }

    if (translate.textContent !== text) {
      translate.textContent = text;
    }
  }

  function restoreTransitionTypeCardDescription(btn) {
    if (!btn) return;
    var description = btn.querySelector('.la-label-description[data-ciw-la-transition-desc]');
    if (!description) return;
    var type = description.getAttribute('data-ciw-la-transition-desc');
    description.removeAttribute('data-ciw-la-transition-desc');
    if (type === 'xtr') description.remove();
  }

  function ensureTransitionTypeLogos(btn) {
    if (!btn) return;

    var progressiveScope = btn.closest('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)');
    if (progressiveScope && isProgressiveTypeStepScope(progressiveScope)) {
      btn.classList.remove('ciw-la-lens-card--transitions-gens', 'ciw-la-lens-card--transitions-xtr');
      restoreTransitionTypeTitleText(btn);
      restoreTransitionTypeCardDescription(btn);
      removeTransitionTypeLogos(btn);
      layoutProgressiveTypeCard(btn);
      return;
    }

    if (!isTransitionTypeStepBtn(btn)) {
      btn.classList.remove('ciw-la-lens-card--transitions-gens', 'ciw-la-lens-card--transitions-xtr');
      restoreTransitionTypeTitleText(btn);
      restoreTransitionTypeCardDescription(btn);
      removeTransitionTypeLogos(btn);
      return;
    }

    var isGenS = isTransitionsGenSCard(btn);
    var isXtr = isTransitionsXTRActiveCard(btn);
    var isPhotocromic = isPhotocromicTransitionTypeCard(btn);

    if (!isGenS && !isXtr && !isPhotocromic) {
      btn.classList.remove('ciw-la-lens-card--transitions-gens', 'ciw-la-lens-card--transitions-xtr');
      restoreTransitionTypeTitleText(btn);
      restoreTransitionTypeCardDescription(btn);
      removeTransitionTypeLogos(btn);
      return;
    }

    if (isPhotocromic) {
      btn.classList.remove('ciw-la-lens-card--transitions-gens', 'ciw-la-lens-card--transitions-xtr');
      restoreTransitionTypeTitleText(btn);
      removeTransitionTypeLogos(btn);
      ensureTransitionTypeCardDescription(btn, PHOTOCHROMIC_CARD_DESCRIPTION, 'photocromic');
      return;
    }

    if (isGenS) {
      btn.classList.remove('ciw-la-lens-card--transitions-xtr');
      var removedXtr = btn.querySelector('.ciw-la-transitions-xtr-logo');
      if (removedXtr) removedXtr.remove();
      ensureTransitionTypeGenSLogo(btn);
      return;
    }

    btn.classList.remove('ciw-la-lens-card--transitions-gens');
    var removedGens = btn.querySelector('.ciw-la-transitions-gens-logo');
    if (removedGens) removedGens.remove();
    if (isTransitionsXTRPolarizedCard(btn)) {
      ensureTransitionTypeXTRPolarizedLogo(btn);
    } else {
      ensureTransitionTypeXTRLogo(btn);
    }
  }

  var MOST_POPULAR_BADGE_LABEL = '★ Most Popular';

  function ensureMostPopularBadge(btn) {
    if (!btn) return;

    if (!isLensTypeStepBtn(btn)) {
      btn.classList.remove('ciw-la-lens-card--most-popular');
      var removedBadge = btn.querySelector('.ciw-la-lens-most-popular-badge');
      if (removedBadge) removedBadge.remove();
      return;
    }

    if (!isBlueLightBlockingLensType(btn)) {
      btn.classList.remove('ciw-la-lens-card--most-popular');
      var existing = btn.querySelector('.ciw-la-lens-most-popular-badge');
      if (existing) existing.remove();
      return;
    }

    btn.classList.add('ciw-la-lens-card--most-popular');

    var badge = btn.querySelector('.ciw-la-lens-most-popular-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'ciw-la-lens-most-popular-badge';
      badge.setAttribute('aria-hidden', 'true');
      btn.appendChild(badge);
    }
    badge.textContent = MOST_POPULAR_BADGE_LABEL;
  }

  function isColorLensCard(btn) {
    if (!btn) return false;
    return isLikelyLensColorCardName(getCardTitleText(btn).split(' - ')[0]);
  }

  function normalizeIconWrap(iconWrap) {
    if (!iconWrap) return null;
    if (
      iconWrap.classList.contains('la-label-image') &&
      iconWrap.parentElement &&
      iconWrap.parentElement.classList.contains('la-label-image-wapper')
    ) {
      return iconWrap.parentElement;
    }
    return iconWrap;
  }

  function iconWrapHasVisual(iconWrap) {
    if (!iconWrap) return false;
    return !!iconWrap.querySelector('img, svg');
  }

  function getColorSwatchTint(colorName) {
    var label = String(colorName || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
      .split(' - ')[0];
    if (/^gr[ae]y$/i.test(label)) return '#6b7280';
    if (/^brown$/i.test(label)) return '#8b5e3c';
    if (/^graphite$/i.test(label)) return '#4b5563';
    if (/^green$/i.test(label)) return '#556b2f';
    if (/^g[\s.-]?15$/i.test(label)) return '#556b2f';
    if (/^amber$/i.test(label)) return '#d97706';
    if (/^amethyst$/i.test(label)) return '#9333ea';
    if (/^ruby$/i.test(label)) return '#dc2626';
    if (/^sapphire$/i.test(label)) return '#2563eb';
    if (/^emerald$/i.test(label)) return '#059669';
    if (/^style\s*colors?$/i.test(label)) return '#6366f1';
    return '#9ca3af';
  }

  function removeEmptyColorIconWrap(head, btn) {
    var iconWrap =
      normalizeIconWrap(head.querySelector(':scope > .la-label-image-wapper, :scope > .la-label-image')) ||
      normalizeIconWrap(findIconWrap(btn));
    if (iconWrap && !iconWrapHasVisual(iconWrap)) {
      iconWrap.remove();
    }
  }

  function ensureColorCardIcon(btn, head) {
    if (!head) return;

    if (!isColorLensCard(btn)) {
      btn.classList.remove('ciw-la-lens-color-card', 'ciw-la-lens-card--has-icon');
      return;
    }

    btn.classList.add('ciw-la-lens-color-card', 'ciw-la-lens-card--has-icon');
    var titleText = getCardTitleText(btn);
    var iconWrap =
      normalizeIconWrap(head.querySelector(':scope > .la-label-image-wapper, :scope > .la-label-image')) ||
      normalizeIconWrap(findIconWrap(btn));

    if (iconWrap && iconWrapHasVisual(iconWrap)) {
      if (iconWrap.parentNode !== head) {
        head.insertBefore(iconWrap, head.firstChild);
      }
      var injected = head.querySelector('.ciw-la-color-swatch-icon');
      if (injected) injected.remove();
      return;
    }

    removeEmptyColorIconWrap(head, btn);

    var swatch = head.querySelector('.ciw-la-color-swatch-icon');
    if (!swatch) {
      swatch = document.createElement('span');
      swatch.className = 'ciw-la-color-swatch-icon';
      swatch.setAttribute('aria-hidden', 'true');
      head.insertBefore(swatch, head.firstChild);
    }
    swatch.style.setProperty('--ciw-la-color-swatch', getColorSwatchTint(titleText));
  }

  function undoLensLayoutIfNeeded(btn) {
    var head = btn.querySelector('.ciw-la-lens-card-head');
    if (!head) return;

    var titleRow = head.querySelector('.ciw-la-lens-card-title-row');
    var title = titleRow && titleRow.querySelector('.la-label-title');
    var description = btn.querySelector('.la-label-description');
    var iconWrap =
      head.querySelector('.la-label-image-wapper, .la-label-image') || findIconWrap(btn);

    var contentBox = btn.querySelector('.la-label-content-box');
    if (!contentBox) {
      contentBox = document.createElement('div');
      contentBox.className = 'la-label-content-box';
    }

    if (iconWrap && iconWrap.parentNode === head) {
      head.removeChild(iconWrap);
      btn.insertBefore(iconWrap, btn.firstChild);
    }

    if (title && title.parentNode !== contentBox) {
      contentBox.appendChild(title);
    }

    if (description && description.parentNode !== contentBox) {
      contentBox.appendChild(description);
    }

    if (contentBox.childNodes.length && contentBox.parentNode !== btn) {
      var insertBefore = iconWrap ? iconWrap.nextSibling : btn.firstChild;
      btn.insertBefore(contentBox, insertBefore);
    }

    head.remove();
    btn.classList.remove('ciw-la-lens-card--ready');
  }

  function setAddonTitleText(titleEl, text) {
    if (!titleEl) return;
    var translate = titleEl.querySelector('la-translate');
    if (translate) {
      translate.textContent = text;
    } else {
      titleEl.textContent = text;
    }
  }

  function applyAddonTitleOverrides(btn) {
    var title = btn.querySelector('.la-label-title');
    if (!title) return;
    var raw = (title.textContent || '').replace(/\s+/g, ' ').trim();
    if (/zeiss\s+duravision\s+platinum\s+uv/i.test(raw)) {
      setAddonTitleText(title, 'Zeiss DuraVision w/ UV');
    }
  }

  function ensureAddonTextLayout(btn) {
    var title = btn.querySelector('.la-label-title');
    var description = btn.querySelector('.la-label-description');
    if (!title) return;

    var stack = btn.querySelector('.ciw-la-addon-text-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'ciw-la-addon-text-stack';
    }

    var head = stack.querySelector(':scope > .ciw-la-lens-card-head');
    if (!head) {
      head = document.createElement('div');
      head.className = 'ciw-la-lens-card-head';
      var titleRow = document.createElement('div');
      titleRow.className = 'ciw-la-lens-card-title-row';
      head.appendChild(titleRow);
      stack.appendChild(head);
    }

    var titleRow = head.querySelector('.ciw-la-lens-card-title-row');
    if (title.parentNode !== titleRow) {
      titleRow.appendChild(title);
    }

    if (description && (description.parentNode !== stack || description.previousElementSibling !== head)) {
      stack.insertBefore(description, head.nextSibling);
    }

    if (stack.parentNode !== btn) {
      var iconWrap = findIconWrap(btn);
      var contentBox = btn.querySelector('.la-label-content-box');
      if (contentBox && contentBox.parentNode === btn) {
        contentBox.replaceWith(stack);
      } else if (iconWrap && iconWrap.parentNode === btn) {
        iconWrap.insertAdjacentElement('afterend', stack);
      } else {
        btn.insertBefore(stack, btn.firstChild);
      }
    }

    var orphanBox = btn.querySelector('.la-label-content-box');
    if (
      orphanBox &&
      orphanBox !== stack &&
      !orphanBox.querySelector('.la-label-title, .la-label-description')
    ) {
      orphanBox.remove();
    }
  }

  function layoutAddonCard(btn) {
    if (!btn) return;

    undoLensLayoutIfNeeded(btn);
    ensureAddonTextLayout(btn);
    applyAddonTitleOverrides(btn);

    var price = btn.querySelector('.la-label-price');
    var priceInline = btn.querySelector('.ciw-la-lens-card-price-inline');
    var priceText = getPriceText(price);

    if (priceText) {
      if (!priceInline) {
        priceInline = document.createElement('span');
        priceInline.className = 'ciw-la-lens-card-price-inline';
        btn.appendChild(priceInline);
      }
      priceInline.textContent = priceText;
    }

    if (price) {
      price.classList.add('ciw-la-lens-card-price-hidden');
    }

    ensureAddonCheckmark(btn);
    markDeclineCard(btn);

    btn.classList.add('ciw-la-addon-card--ready');
  }

  function ensureAddonCheckmark(btn) {
    if (!btn || btn.querySelector('.ciw-la-addon-card-check')) return;
    var mark = document.createElement('span');
    mark.className = 'ciw-la-addon-card-check';
    mark.setAttribute('aria-hidden', 'true');
    btn.appendChild(mark);
  }

  function isBtnInLensPackageScope(btn) {
    if (!btn) return false;
    var scope = btn.closest('.la-choose-prescription-wrapper');
    return scope ? isLensPackageOptionScope(scope) : false;
  }

  function packageDescHtmlToPlainText(html) {
    if (!html) return '';
    var node = document.createElement('div');
    node.innerHTML = String(html);
    return (node.textContent || node.innerText || '').replace(/\s+/g, ' ').trim();
  }

  /* LA stores package-tier blurbs on raw_options but often leaves .la-label-description
     empty on the sunglasses/options "Choose lens package" step (tooltip repeats the title). */
  function getPackageTierDescriptionFromLa(tierName) {
    var label = String(tierName || '')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' - ')[0];
    if (!label || !isLikelyThicknessTierName(label)) return '';

    var la = window.LensAdvizor;
    var lens = la && la.response && la.response.lens;
    var rawOptions = lens && lens.raw_options;
    if (!Array.isArray(rawOptions)) return '';

    var needle = label.toLowerCase();
    var i;
    var j;
    for (i = 0; i < rawOptions.length; i++) {
      var option = rawOptions[i];
      if (!option || !Array.isArray(option.values)) continue;
      for (j = 0; j < option.values.length; j++) {
        var value = option.values[j];
        if (!value || !value.name || !value.description) continue;
        var valueName = String(value.name)
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();
        if (valueName === needle) {
          return packageDescHtmlToPlainText(value.description);
        }
      }
    }
    return '';
  }

  function getExistingPackageDescriptionText(btn) {
    var description = btn && btn.querySelector('.la-label-description');
    if (!description) return '';
    return (description.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function ensurePackageCardDescription(btn) {
    if (!btn || isSunglassesLensSelectionBtn(btn) || isColorLensCard(btn)) return;

    var titleText = getCardTitleText(btn);
    if (!isLikelyThicknessTierName(titleText)) return;

    var text = getPackageTierDescriptionFromLa(titleText);
    if (!text) return;

    var existing = getExistingPackageDescriptionText(btn);
    var titleNorm = titleText.toLowerCase();
    /* Keep a real LA-rendered description; replace title-only / empty placeholders. */
    if (existing && existing.toLowerCase() !== titleNorm && existing.length > titleText.length + 8) {
      return;
    }

    var description = btn.querySelector('.la-label-description');
    if (!description) {
      description = document.createElement('div');
      description.className = 'la-label-description';

      var head = btn.querySelector('.ciw-la-lens-card-head');
      var contentBox = btn.querySelector('.la-label-content-box');
      var titleEl = btn.querySelector('.la-label-title');

      if (head) {
        head.insertAdjacentElement('afterend', description);
      } else if (contentBox && titleEl && contentBox.contains(titleEl)) {
        titleEl.insertAdjacentElement('afterend', description);
      } else if (titleEl && titleEl.parentNode) {
        titleEl.insertAdjacentElement('afterend', description);
      } else {
        btn.appendChild(description);
      }
    }

    description.setAttribute('data-ciw-la-package-desc', '1');

    var translate = description.querySelector('la-translate');
    if (!translate) {
      translate = document.createElement('la-translate');
      description.textContent = '';
      description.appendChild(translate);
    }

    if (translate.textContent !== text) {
      translate.textContent = text;
    }
  }

  function restoreDesktopLensPackageCard(btn) {
    if (!btn) return;

    undoLensLayoutIfNeeded(btn);

    btn.querySelectorAll('.ciw-la-lens-card-price-inline').forEach(function (node) {
      node.remove();
    });

    btn.querySelectorAll('.la-label-price.ciw-la-lens-card-price-hidden').forEach(function (price) {
      price.classList.remove('ciw-la-lens-card-price-hidden');
    });

    btn.classList.remove('ciw-la-lens-card--ready');
    markBasicCard(btn);
    ensurePackageCardDescription(btn);
  }

  function consolidateLensPackageCardDom(btn) {
    var title = btn.querySelector('.la-label-title');
    if (!title) return null;

    var description = btn.querySelector('.la-label-description');
    var isColorCard = isColorLensCard(btn);
    var head = btn.querySelector('.ciw-la-lens-card-head');

    if (!head) {
      head = document.createElement('div');
      head.className = 'ciw-la-lens-card-head';
      btn.insertBefore(head, btn.firstChild);
    }

    var titleRow = head.querySelector('.ciw-la-lens-card-title-row');
    if (!titleRow) {
      titleRow = document.createElement('div');
      titleRow.className = 'ciw-la-lens-card-title-row';
      head.appendChild(titleRow);
    }

    if (title.parentNode !== titleRow) {
      titleRow.appendChild(title);
    }

    if (description && (description.parentNode !== btn || description.previousElementSibling !== head)) {
      head.insertAdjacentElement('afterend', description);
    }

    btn.querySelectorAll('.la-label-content-box').forEach(function (box) {
      box.remove();
    });

    if (!isColorCard) {
      btn.querySelectorAll(':scope > .la-label-image, :scope > .la-label-image-wapper').forEach(function (node) {
        node.remove();
      });
      head.querySelectorAll(
        ':scope > .la-label-image, :scope > .la-label-image-wapper, :scope > .ciw-la-color-swatch-icon'
      ).forEach(function (node) {
        node.remove();
      });
    }

    return head;
  }

  function layoutTransitionsLensPackageCard(btn) {
    if (!btn || !btn.querySelector('.la-label-title')) return;

    var head = consolidateLensPackageCardDom(btn);
    if (!head) return;

    var titleRow = head.querySelector('.ciw-la-lens-card-title-row');
    if (titleRow) {
      ensureRecBadge(btn, titleRow);
    }

    var price = btn.querySelector('.la-label-price');
    var priceText = getPriceText(price);

    if (priceText) {
      var priceInline = btn.querySelector('.ciw-la-lens-card-price-inline');
      if (!priceInline) {
        priceInline = document.createElement('span');
        priceInline.className = 'ciw-la-lens-card-price-inline';
        btn.appendChild(priceInline);
      }
      priceInline.textContent = priceText;
    }

    if (price) {
      price.classList.add('ciw-la-lens-card-price-hidden');
    }

    pinPriceToCard(btn, head);
    markBasicCard(btn);
    ensureColorCardIcon(btn, head);
    ensurePackageCardDescription(btn);
    btn.classList.add('ciw-la-lens-card--ready');
  }

  function removeOrphanContentBox(btn) {
    if (!btn || !btn.querySelector('.ciw-la-lens-card-head')) return;
    var contentBox = btn.querySelector('.la-label-content-box');
    if (!contentBox) return;
    if (contentBox.querySelector('.la-label-title, .la-label-description')) return;
    contentBox.remove();
  }

  function ensureHeadLayout(btn, head) {
    var titleRow = head.querySelector('.ciw-la-lens-card-title-row');

    btn.querySelectorAll('.la-label-content-box').forEach(function (box) {
      if (!box.querySelector('.la-label-title, .la-label-description')) {
        box.remove();
        return;
      }
      if (head.querySelector('.la-label-title')) {
        box.remove();
      }
    });

    if (titleRow) {
      ensureRecBadge(btn, titleRow);
    }

    pinPriceToCard(btn, head);

    markBasicCard(btn);

    var existingDesc = btn.querySelector('.la-label-description');
    if (
      existingDesc &&
      existingDesc.compareDocumentPosition(head) & Node.DOCUMENT_POSITION_FOLLOWING
    ) {
      head.insertAdjacentElement('afterend', existingDesc);
    }

    ensureColorCardIcon(btn, head);
    removeOrphanContentBox(btn);
  }

  function layoutCard(btn) {
    if (!btn) return;
    if (isSunglassesLensSelectionBtn(btn)) return;

    if (isProgressiveTypeCard(btn)) {
      layoutProgressiveTypeCard(btn);
      return;
    }

    if (isBtnInLensPackageScope(btn)) {
      if (!isMobileViewport()) {
        restoreDesktopLensPackageCard(btn);
        return;
      }
      layoutTransitionsLensPackageCard(btn);
      return;
    }

    var existingHead = btn.querySelector('.ciw-la-lens-card-head');
    if (existingHead) {
      if (isProgressiveTypeCard(btn)) {
        layoutProgressiveTypeCard(btn);
      } else {
        ensureHeadLayout(btn, existingHead);
      }
      btn.classList.add('ciw-la-lens-card--ready');
      return;
    }

    if (btn.classList.contains('ciw-la-lens-card--ready')) return;

    var contentBox = btn.querySelector('.la-label-content-box');
    var title = btn.querySelector('.la-label-title');
    var description = btn.querySelector('.la-label-description');
    var price = btn.querySelector('.la-label-price');
    var iconWrap = findIconWrap(btn);

    if (!title) return;

    var isColorCard = isColorLensCard(btn);

    var head = document.createElement('div');
    head.className = 'ciw-la-lens-card-head';

    if (iconWrap && !isColorCard) {
      iconWrap.remove();
    }

    var titleRow = document.createElement('div');
    titleRow.className = 'ciw-la-lens-card-title-row';
    titleRow.appendChild(title);

    head.appendChild(titleRow);

    var priceText = getPriceText(price);
    if (priceText) {
      var priceInline = document.createElement('span');
      priceInline.className = 'ciw-la-lens-card-price-inline';
      priceInline.textContent = priceText;
      btn.appendChild(priceInline);
    }

    if (price) {
      price.classList.add('ciw-la-lens-card-price-hidden');
    }

    if (description && contentBox && description.parentNode === contentBox) {
      contentBox.removeChild(description);
    }

    var anchor = contentBox || price;
    if (anchor && anchor.parentNode === btn) {
      btn.insertBefore(head, anchor);
    } else {
      btn.insertBefore(head, btn.firstChild);
    }

    ensureRecBadge(btn, titleRow);

    if (description) {
      head.insertAdjacentElement('afterend', description);
    }

    if (contentBox) {
      contentBox.remove();
    }

    if (isColorCard) {
      ensureColorCardIcon(btn, head);
    }

    markBasicCard(btn);

    btn.classList.add('ciw-la-lens-card--ready');
  }

  function scanProgressiveTypeIcons(root) {
    var rootNode = root || document;
    rootNode
      .querySelectorAll(
        '.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step.la-render-options, .la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)'
      )
      .forEach(function (scope) {
        if (isSunglassesLensSelectionScope(scope)) return;
        if (!isProgressiveTypeStepScope(scope)) return;
        scope.querySelectorAll('.la-label-btn').forEach(layoutProgressiveTypeCard);
      });
  }

  function scanLensGroupBadges(root) {
    var rootNode = root || document;
    var scope = rootNode.querySelector('.la-choose-prescription-wrapper.la-render-lenses.x-pro');
    if (!scope) return;
    scope.querySelectorAll('.la-label-btn').forEach(function (btn) {
      ensureMostPopularBadge(btn);
      ensureTransitionsLogo(btn);
    });
  }

  function scanTransitionTypeLogos(root) {
    var rootNode = root || document;
    var scope = rootNode.querySelector('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)');
    if (!scope) return;
    scope.querySelectorAll('.la-label-btn').forEach(function (btn) {
      ensureTransitionTypeLogos(btn);
    });
  }

  var PACKAGE_PICKED_CLASS = 'ciw-la-lens-card--picked';

  function isStandardTierTitle(title) {
    return /^standard$/i.test(
      String(title || '')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' - ')[0]
    );
  }

  function isPolycarbonateTierTitle(title) {
    return /^polycarbonate$/i.test(
      String(title || '')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' - ')[0]
    );
  }

  function getProductFrameType() {
    var el = document.querySelector('.ciw-pdp[data-ciw-frame-type]');
    if (el) {
      var attr = (el.getAttribute('data-ciw-frame-type') || '').replace(/\s+/g, ' ').trim();
      if (attr) return attr;
    }
    if (window.__CIW_PDP_FRAME_TYPE) {
      return String(window.__CIW_PDP_FRAME_TYPE).replace(/\s+/g, ' ').trim();
    }
    return '';
  }

  /* Half rim / semi-rimless / rimless frames need polycarbonate for drill mounts. */
  function prefersPolycarbonatePackage() {
    var frameType = getProductFrameType();
    if (/half\s*rim|semi[\s_-]*rim|rimless/i.test(frameType)) return true;

    var handleHint = '';
    var pdp = document.querySelector('.ciw-pdp[data-url]');
    if (pdp) handleHint = pdp.getAttribute('data-url') || '';
    if (!handleHint) handleHint = location.pathname || '';
    return /semi-rimless|half-rim|rimless/i.test(handleHint);
  }

  function findPolycarbonatePackageWrapper(scope) {
    var wrappers = getPackageCardWrappers(scope);
    var i;
    for (i = 0; i < wrappers.length; i++) {
      if (isPolycarbonateTierTitle(getPackageCardTitle(wrappers[i]))) {
        return wrappers[i];
      }
    }
    return null;
  }

  function ensureInlinePackageRecBadge(btn, outerWrapper) {
    if (!btn || !outerWrapper) return;
    var title = btn.querySelector('.la-label-title');
    if (!title) return;

    /* Desktop package cards keep LA's content-box (no head). Wrap title + badge
       in a title-row so the pill sits on the same line as the name. */
    var titleRow = btn.querySelector('.ciw-la-lens-card-title-row');
    if (!titleRow) {
      titleRow = document.createElement('div');
      titleRow.className = 'ciw-la-lens-card-title-row';
      if (title.parentNode) {
        title.parentNode.insertBefore(titleRow, title);
      }
      titleRow.appendChild(title);
    } else if (title.parentNode !== titleRow) {
      titleRow.appendChild(title);
    }

    ensureRecBadge(btn, titleRow);
  }

  function markForcedPackageRecommendation(target, scope) {
    if (!target || !scope) return;

    getPackageCardWrappers(scope).forEach(function (wrapper) {
      if (wrapper === target) return;
      wrapper.classList.remove(
        'recommendation-label-container',
        'boxy-recommendation-label-container',
        'ciw-la-lens-card--badge-moved'
      );
      var otherBtn = getPackageCardBtn(wrapper);
      if (!otherBtn) return;
      otherBtn.querySelectorAll('.ciw-la-lens-rec-badge').forEach(function (node) {
        node.remove();
      });
    });

    target.classList.add('recommendation-label-container');
    if (target.classList.contains('la-horizontal-boxy-label-wrapper')) {
      target.classList.add('boxy-recommendation-label-container');
    }

    var btn = getPackageCardBtn(target);
    if (!btn) return;

    var titleRow = btn.querySelector('.ciw-la-lens-card-title-row');
    if (titleRow) {
      ensureRecBadge(btn, titleRow);
    } else {
      ensureInlinePackageRecBadge(btn, target);
    }
  }

  function getPackageCardWrappers(scope) {
    if (!scope) return [];
    var wrappers = Array.prototype.slice.call(
      scope.querySelectorAll('.la-label-btn-wrapper, .la-horizontal-boxy-label-wrapper')
    );
    if (!wrappers.length) {
      wrappers = Array.prototype.slice.call(scope.querySelectorAll('label.la-label-btn, div.la-label-btn'));
    }

    /* Combined sunglasses option forms keep tint colors + package tiers in one
       list. Recommendation / outline must only consider real package tiers. */
    var tierWrappers = wrappers.filter(function (wrapper) {
      if (
        wrapper.classList &&
        wrapper.classList.contains('ciw-la-sunglasses-outgoing-color-card')
      ) {
        return false;
      }
      var title = getPackageCardTitle(wrapper);
      if (isLikelyLensColorCardName(title)) return false;
      return isLikelyThicknessTierName(title);
    });

    return tierWrappers.length ? tierWrappers : wrappers;
  }

  function getPackageCardBtn(wrapper) {
    if (!wrapper) return null;
    if (wrapper.classList && wrapper.classList.contains('la-label-btn')) return wrapper;
    return wrapper.querySelector('.la-label-btn');
  }

  function getPackageCardTitle(wrapper) {
    var btn = getPackageCardBtn(wrapper);
    if (!btn) return '';
    var titleNode = btn.querySelector('.la-label-title');
    return titleNode
      ? String(titleNode.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .split(' - ')[0]
      : '';
  }

  function isSunglassesLensTypeTitle(title) {
    return /^(solid tint|gradient tint|polarized)$/i.test(
      String(title || '').replace(/\s+/g, ' ').trim()
    );
  }

  function isTransitionsDrawerScope(scope) {
    if (!scope || !scope.classList.contains('la-render-lenses') || scope.classList.contains('x-pro')) {
      return false;
    }
    return scope.classList.contains('ciw-la-transitions-drawer-step');
  }

  function isSunglassesLensSelectionScope(scope) {
    if (!scope || !scope.classList.contains('la-render-lenses') || scope.classList.contains('x-pro')) {
      return false;
    }
    if (scope.classList.contains('ciw-la-sunglasses-lens-selection-step')) return true;

    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    var typeCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
      if (isSunglassesLensTypeTitle(cardTitle)) typeCount++;
    }
    return typeCount >= 2;
  }

  function isSunglassesLensSelectionBtn(btn) {
    if (!btn || !btn.closest) return false;
    var scope = btn.closest('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)');
    return isSunglassesLensSelectionScope(scope);
  }

  function isClassicLensPackageScope(scope) {
    if (!scope || !scope.classList.contains('la-render-lenses') || scope.classList.contains('x-pro')) {
      return false;
    }
    return /choose\s+lens\s+package/i.test(getLensPackageScopeTitle(scope));
  }

  function findStandardPackageWrapper(scope) {
    var wrappers = getPackageCardWrappers(scope);
    var i;
    for (i = 0; i < wrappers.length; i++) {
      if (isStandardTierTitle(getPackageCardTitle(wrappers[i]))) {
        return wrappers[i];
      }
    }
    return null;
  }

  function findRecommendedPackageWrapper(scope) {
    var wrappers = getPackageCardWrappers(scope);
    var i;
    for (i = 0; i < wrappers.length; i++) {
      if (
        wrappers[i].classList.contains('recommendation-label-container') ||
        wrappers[i].classList.contains('boxy-recommendation-label-container')
      ) {
        return wrappers[i];
      }
    }
    return null;
  }

  function findCheckedPackageWrapper(scope) {
    var wrappers = getPackageCardWrappers(scope);
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var radio = wrappers[i].querySelector('input[type="radio"].la-tap-select');
      if (radio && radio.checked) return wrappers[i];
    }
    return null;
  }

  function paintPackageRecommendation(scope) {
    if (!scope || !isScopeVisible(scope)) return;

    var polyPreferred = prefersPolycarbonatePackage();
    var polyTarget = polyPreferred ? findPolycarbonatePackageWrapper(scope) : null;

    /* Sunglasses combined package step — progressive package continue owns the
       picked outline. Painting here used to mark the hidden checked tint color
       (e.g. Gray) and strip the outline from Polycarbonate/Standard.
       Still force the Polycarbonate recommendation badge when frame type needs it. */
    if (
      scope.classList.contains('la-render-options') &&
      scope.classList.contains(LENS_PACKAGE_SCOPE_CLASS) &&
      (document.body.classList.contains('ciw-la-sunglasses-post-confirm') ||
        document.body.classList.contains('ciw-la-sunglasses-package-revealed') ||
        document.body.classList.contains('ciw-la-progressive-package-active'))
    ) {
      if (polyTarget) markForcedPackageRecommendation(polyTarget, scope);
      return;
    }

    var wrappers = getPackageCardWrappers(scope);
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var btn = getPackageCardBtn(wrapper);
      if (btn) markBasicCard(btn);
    });

    var target =
      polyTarget ||
      findStandardPackageWrapper(scope) ||
      findRecommendedPackageWrapper(scope) ||
      findCheckedPackageWrapper(scope) ||
      wrappers[0];

    if (polyTarget) {
      markForcedPackageRecommendation(polyTarget, scope);
    }

    wrappers.forEach(function (wrapper) {
      var btn = getPackageCardBtn(wrapper);
      if (!btn) return;
      btn.classList.toggle(PACKAGE_PICKED_CLASS, wrapper === target);
    });
  }

  function syncLensPackageVisualDefaults(root) {
    var rootNode = root || document;

    var classicScope = rootNode.querySelector('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)');
    if (classicScope && isClassicLensPackageScope(classicScope)) {
      paintPackageRecommendation(classicScope);
    }

    var packageScope = getLensPackageScope(rootNode);
    if (packageScope && isScopeVisible(packageScope)) {
      paintPackageRecommendation(packageScope);
    }

    if (!document.body.classList.contains('ciw-la-lens-thickness-continue-active')) {
      var thicknessScope = getThicknessScope(rootNode);
      if (thicknessScope && isScopeVisible(thicknessScope)) {
        paintPackageRecommendation(thicknessScope);
      }
    }
  }

  var scanRunning = false;
  var scanBurstQueued = false;

  function scan(root) {
    if (scanRunning) return;
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isEyeglass()) return;
    scanRunning = true;
    try {
    var rootNode = root || document;
    STEP_SELECTORS.forEach(function (selector) {
      var scope = rootNode.querySelector(selector);
      if (!scope) return;
      if (isSunglassesLensSelectionScope(scope)) return;
      if (isTransitionsDrawerScope(scope)) return;
      var isAddons = scope.classList.contains('la-render-addons');
      scope.querySelectorAll('.la-label-btn').forEach(function (btn) {
        if (isAddons) {
          layoutAddonCard(btn);
        } else {
          layoutCard(btn);
        }
      });
    });

    clearStaleThicknessScopes(rootNode);

    var lensPackageScope = getLensPackageScope(rootNode);
    if (lensPackageScope) {
      lensPackageScope.classList.remove(THICKNESS_SCOPE_CLASS, 'ciw-la-lens-color-step');
      lensPackageScope.classList.add(LENS_PACKAGE_SCOPE_CLASS);
      if (isMobileViewport()) {
        lensPackageScope.querySelectorAll('.la-label-btn').forEach(layoutTransitionsLensPackageCard);
      } else {
        lensPackageScope.querySelectorAll('.la-label-btn').forEach(restoreDesktopLensPackageCard);
      }
    } else {
      rootNode.querySelectorAll('.' + LENS_PACKAGE_SCOPE_CLASS).forEach(function (el) {
        el.classList.remove(LENS_PACKAGE_SCOPE_CLASS);
      });
    }

    syncLensPackageContentBodyLayout(rootNode);

    var thicknessScope = getThicknessScope(rootNode);
    if (thicknessScope) {
      thicknessScope.classList.remove(LENS_PACKAGE_SCOPE_CLASS);
      thicknessScope.classList.add(THICKNESS_SCOPE_CLASS);
      thicknessScope.querySelectorAll('.la-label-btn').forEach(layoutCard);
    }

    var optionsScope = rootNode.querySelector('.la-choose-prescription-wrapper.la-render-options');
    if (
      optionsScope &&
      optionsScope !== thicknessScope &&
      optionsScope !== lensPackageScope &&
      window.ciwLaLensColorContinue &&
      typeof window.ciwLaLensColorContinue.isColorScope === 'function' &&
      window.ciwLaLensColorContinue.isColorScope(optionsScope)
    ) {
      optionsScope.querySelectorAll('.la-label-btn').forEach(layoutCard);
    }

    scanLensGroupBadges(rootNode);
    scanTransitionTypeLogos(rootNode);
    scanProgressiveTypeIcons(rootNode);
    scanLensPackageInlineWidths(rootNode);
    syncLensPackageVisualDefaults(rootNode);
    } finally {
      scanRunning = false;
    }
  }

  function runScanBurst() {
    scan();
    window.setTimeout(scan, 0);
    window.setTimeout(scan, 150);
    window.setTimeout(scan, 400);
    window.setTimeout(scan, 800);
    window.setTimeout(scan, 1500);
  }

  function scheduleScan() {
    if (scanBurstQueued) return;
    scanBurstQueued = true;
    window.requestAnimationFrame(function () {
      scanBurstQueued = false;
      runScanBurst();
    });
  }

  var EVENTS = [
    'LensAdvizor:lens:rendered',
    'LensAdvizor:lensOptions:rendered',
    'LensAdvizor:addOns:rendered',
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:prescriptionTypes:rendered'
  ];

  EVENTS.forEach(function (eventName) {
    document.addEventListener(eventName, scheduleScan);
  });

  function layoutProgressiveTypeStep(root) {
    scanProgressiveTypeIcons(root || document);
  }

  document.addEventListener('ciw-la-lens-package:scan-now', function (event) {
    var root = (event && event.detail && event.detail.root) || document;
    layoutProgressiveTypeStep(root);
    window.requestAnimationFrame(function () {
      layoutProgressiveTypeStep(root);
    });
    window.setTimeout(function () {
      layoutProgressiveTypeStep(root);
    }, 80);
  });

  document.addEventListener('ciw-la-progressive-type:layout', function (event) {
    var root = (event && event.detail && event.detail.root) || document;
    layoutProgressiveTypeStep(root);
  });

  window.ciwLaLensPackageLayout = window.ciwLaLensPackageLayout || {};
  window.ciwLaLensPackageLayout.layoutProgressiveTypeStep = layoutProgressiveTypeStep;
  window.ciwLaLensPackageLayout.prefersPolycarbonatePackage = prefersPolycarbonatePackage;
  window.ciwLaLensPackageLayout.findPolycarbonatePackageWrapper = findPolycarbonatePackageWrapper;
  window.ciwLaLensPackageLayout.markForcedPackageRecommendation = markForcedPackageRecommendation;

  document.addEventListener('ciw-la-lens-color:combined-phase-b', scheduleScan);

  document.addEventListener('DOMContentLoaded', scheduleScan);

  var mobileMedia = window.matchMedia('(max-width: 749px)');
  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', scheduleScan);
  } else if (typeof mobileMedia.addListener === 'function') {
    mobileMedia.addListener(scheduleScan);
  }

  var modal = document.getElementById('lensadvizor-prescription-modal');
  if (modal) {
    new MutationObserver(scheduleScan).observe(modal, {
      childList: true,
      subtree: true
    });
  }
})();
